import React from 'react'
import "react-datepicker/dist/react-datepicker.css";
import { useState, useEffect,useRef, useMemo} from 'react';
import './classes/ApplicantEditProfile.css';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { configData } from "../config";
import Loading from './Loading';
import SweetAlert2 from 'react-sweetalert2';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { format } from "date-fns";
import Editor from 'react-simple-wysiwyg';
import TimeInput from './TimeInput';
import { useTimezoneSelect, allTimezones } from "react-timezone-select";

const labelStyle = "original"
const timezones = {
  ...allTimezones,
  "Europe/Berlin": "Frankfurt",
  'America/Lima': 'Pittsburgh',
}

const ApplicantAdminEditProfile = ({uid,username, userRoles,picture}) => {
    const navigate = useNavigate();

    // const { options, parseTimezone } = useTimezoneSelect({ labelStyle, timezones });
    // const { options: baseOptions, parseTimezone } = useTimezoneSelect({ labelStyle, timezones });

    const mentorSportsList = [
        {value:"cricket", label:"Cricket"},
        {value:"baseball", label:"Baseball"},
        {value:"basketball", label:"Basketball"},
        {value:"football", label:"Football"},
        {value:"hockey", label:"Hockey"},
        {value:"rugby", label:"Rugby"},
        {value:"soccer", label:"Soccer"}
    ];

    const agentCertificateList = [
        'CFL Certified',
        'DEL Certified',
        'FIBA Certified',
        'FIFA Certified',
        'MLB Certified',
        'NBA Certified',
        'NFLPA Certified',
        'NHL Certified',
        'NIL Certified',
        'PHPA Certified',
        'PWHL Certified',
        'WNBA Certified'
    ];

    const months = [
        { value: "01", label: "Jan" },
        { value: "02", label: "Feb" },
        { value: "03", label: "Mar" },
        { value: "04", label: "Apr" },
        { value: "05", label: "May" },
        { value: "06", label: "Jun" },
        { value: "07", label: "Jul" },
        { value: "08", label: "Aug" },
        { value: "09", label: "Sep" },
        { value: "10", label: "Oct" },
        { value: "11", label: "Nov" },
        { value: "12", label: "Dec" }
    ];

    const days = Array.from({ length: 31 }, (_, i) => {
        const day = String(i + 1).padStart(2, "0");
        return { value: day, label: day };
    });

    const currentYear = new Date().getFullYear();
    const maxYear = currentYear + 10; 
    const minYear = currentYear - 10;
    const agentExpirationYears = Array.from(
        { length: maxYear - minYear + 1 },
        (_, i) => {
            const year = String(minYear + i);
            return { value: year, label: year };
        }
    );

    const years = Array.from(
    { length: 7 },
    (_, i) => {
        const year = String(currentYear - 3 + i);
        return { value: year, label: year };
    }
    );

    // const hours = Array.from(
    //     { length: 23 - 0 + 1 },
    //     (_, i) => {
    //     const hour = String(0 + i);
    //     return { value: hour, label: hour };
    //     }
    // );
    const hours = Array.from(
        { length: 24 },
        (_, i) => {
            const hour = String(i).padStart(2, '0'); 
            return { value: hour, label: hour };
        }
    );

    const clock = [
        '00',
        '15',
        '30',
        '45'
    ];

    const schoolYears = Array.from(
        { length: currentYear - 1960 + 1 },
        (_, i) => {
        const schoolYear = String(currentYear - i);
        return { value: schoolYear, label: schoolYear };
        }
    );

    const [formData, setFormData] = useState({
        field_user_assignment:'',
        firstName:'',
        lastName:'',
        field_meta_title:'',
        field_meta_keywords:'',
        field_meta_description:'',
        field_biography:'',
        field_education:'',
        field_career_information:'',
        field_sports_background:'',
        field_professional_background:'',
        field_volunteer_work:'',
        field_mission_statement:'',
        // field_show_on_frontend_agent: 0,
        // field_agent_sort_order: '',
        // field_agent_id: '',
        // field_agent_title: '',
        // field_agent_biography:'',
        // field_delete_agent_photo:0,
        // field_agent_photo:'',
        // field_agent_contract:[],
        // field_agent_sports:[],
        // field_agent_certifications: [],
        // field_special_certifications:[],
        // field_agent_region:'',
        // field_scout_rank:'',
        // field_expiration_date: '',
        // field_show_on_frontend_scout:0,
        // field_scout_sort_order:'',
        // field_scoutid:'',
        // field_scout_title:'',
        // field_scout_biography:'',
        // field_delete_scout_photo:0,
        // field_scout_photo:'',
        // field_scout_contract:[],
        // field_scout_sport:[],
        // field_scout_region: '',
        // field_scout_featured:0,
        // field_mentor_sort_order:'',
        // field_mentor_title:'',
        // field_athlete_contract:[],
        // field_mentor_biography:'',
        // field_mentor_sports:[],
        // field_mentor_region: '',
        field_first_name_badge:'',
        // field_delete_mentor_photo:0,
        // field_mentor_photo:'',
        field_last_name_badge:'',
        field_name_school_badge:'',
        field_name_title_badge:'',
        field_name_org_badge:'',
        field_lead_type:[],
        field_call_back_month:'',
        field_call_back_day:'',
        field_call_back_year:'',
        field_call_back_hour:'',
        field_call_back_minute:'',
        field_call_back_second:'',
        field_lead_sort_flag:'',
        field_lead_priority:'Medium',
        field_street: '',
        field_smww_email:'',
        field_street_2: '',
        field_realemail:'',
        field_city: '',
        field_state: '',
        field_postal_code: '',
        field_country: '',
        // continent:'Asia',
        field_continentid:'',
        field_linkedin_url: '',
        field_appid:'',
        field_phone: '',
        field_secondary_phone: '',
        field_province_region: '',
        field_other_referrer:'',
        field_age:'',
        field_education_state:'',
        field_education_city:'',
        field_school:'',
        field_last_attended:'',
        field_add_to_divvy_draft:'',
        field_sports_recom: '',
        field_referrer: '',
        field_team_refer: '',
        field_gender: '',
        field_highest_grade: '',
        field_college: '',
        field_degree: '',
        field_current_job: '',
        field_major: '',
        field_military: '',
        field_military_id: '',
        field_been_convicted: '',
        field_felony: '',
        field_is_for_credit: '',
        field_team_organization: '',
        field_night_phone:'',
        field_fax:'',
        field_pager:'',
        // field_athelte_id:'',
        field_amount_paid:'',
        field_contact_id:'',
        field_event_id:'',
        field_coupon_code:'',
        field_contact_notes:'',
        field_nationality:'',
        appRegister_step:'',
        field_cuc_degrees: [],
        field_agent_slug:'',
        field_scout_slug:'',
        field_ip_address:'',
        field_doc_talk:[],
        field_favteam: '',
        field_elaborate: '',
        field_date_of_app:'',
        field_date_of_acceptance:'',
        applied_courses:[],
        field_app_status:'2',
        field_sales_call_made:0,
        field_app_is_agent:0,
        field_app_is_scout:0,
        field_over18:0,
        field_dormant:0,
        field_srm400:0,
        field_am400:0,
        field_gi_bill:0,
        field_gi_bill_status: '_none',
        field_new_apply: 0,
        // field_show_on_frontend_athlete:0,
        // field_current_class:0,
        // field_athlete_featured:0,
        // field_available:0,
        // field_show_on_smww_basketball:0,
        // field_date_of_signing: {
        //     date: null,
        //     time: ''
        // },
        // field_agent_expiration_date: {
        //     year:"",
        //     month:"",
        //     day:""
        // },
        // field_agent_expiration_year:'',
        // field_agent_expiration_month:'',
        // field_agent_expiration_date:'',
        // field_agent_featured:0,
        // field_last_date_accept:'',
        // field_signing_agent_id:'',
        // field_current_agent_id:'',
        // field_date_of_assignment: {
        //     date: null,
        //     time: ''
        // },
        // field_athlete_sports:[],
        // field_athlete_position:'',
        //     field_dob: {
        //     date: null,
        //     time: ''
        // },
        // field_athlete_rank:'',
        // field_tier_status:'',
        // field_tier_status_date: {
        //     date: null,
        //     time: ''
        // },
        // field_athlete_type:'',
        field_high_school: '',
        field_hs_location: '',
        field_hs_grad_year: '',
        field_college_grad_date: '',
        field_birthday: '',
        field_reg_step: '3',
        field_hear_about_doc_talk: '',
        field_doctalk_course_month:'',
        // field_athlete_height:'',
        // field_height_unit:'',
        // field_athlete_weight:'',
        // field_weight_unit:'',
        // field_university: '',
        field_instagram_url:'',
        field_instagram_handle:'',
        field_instagram_followers:'',
        field_facebook_url:'',
        field_facebook_handle:'',
        field_facebook_followers:'',
        field_twitter_url:'',
        field_twitter_followers:'',
        field_user_youtube_url:'',
        field_youtube_subscribers:'', 
        field_linkedin_handle:'',
        field_linkedin_followers:'',
        field_tiktok_url:'',
        field_tiktok_followers:'',
        field_cuc_application:'',
        field_talk_with_dr_lashbrook:'',
        field_advanced_certificates_ques:'',
        field_request_more_info:'',
        field_most_recent_college:'',
        field_most_recent_seasons_stats:'',
        field_first_form_submission:'',
        field_last_form_submitted:'',
        field_agents_represented_by: [],
        field_sports_you_worked: [],
        field_other_sports_you_worked:'',
        field_your_dream_job:[],
        field_other_dream_job:'',
        field_job_resume:'',
        field_how_to_contact_client:'',
        field_q_a:'',
        sort_flags:[],
        field_sports_focus: [],
        // field_show_on_frontend_ambassado:0,
        userName:'',
        status:'1',
        roles:['2'],
        current_pass: '',
        mail: '',
        password: '',
        confirmPassword: '',
        field_ambassador_slug:'',
        picture: null,
        pictureDelete: false,
        // timezone: '',
        field_recent_graduation_date:'',
        field_graduated_courses:'',
        field_video_highlights:'',
        field_google_click_id:'',
        field_text_me_with_news_offers:0,
        uid:uid,    
        revision:'',
        button_name:'Save',
        cancel_button:'Cancel account',
        delete_button:'Delete',
        placements: [{ page: '', order: '1' }],
    });
    const[error,setError] = useState({});
    const [originalUserName, setOriginalUserName] = useState('');
    const [fieldErrors, setFieldErrors] = useState({
        userName: false
    });
    const [editorMode, setEditorMode] = useState({
        biography: true,
        education: true,
        qa: true,
        contact: true,
        careerinfo:true,
        agentBio:true,
        scoutBio:true,
        mentorbio:true,
        most_recent_seasons_stats:true,
        video_highlights:true,
    });
   
    const toggleEditor = (field) => {
        const fieldMap = {
            biography: 'field_biography',
            education: 'field_education',
            qa: 'field_q_a',
            contact: 'field_how_to_contact_client',
            careerinfo:'field_career_information',
            agentBio: 'field_agent_biography',
            scoutBio:'field_scout_biography',
            mentorbio:'field_mentor_biography',
            most_recent_seasons_stats:'field_most_recent_seasons_stats',
            video_highlights:'field_video_highlights',
        };
    
        const fieldKey = fieldMap[field];
    
        setEditorMode(prev => {
            const switchingToRich = !prev[field];
        
            setFormData(prevFormData => {
            const value = prevFormData[fieldKey] || '';
            const trimmed = value.trim();
        
            if (switchingToRich) {
                const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(trimmed);
                const hasUnwrappedText = !looksLikeHtml || /^[^<]+|[^>]+$/g.test(trimmed);
        
                if (hasUnwrappedText) {
                const wrapped = `<p>${trimmed.replace(/\n+/g, '</p><p>')}</p>`;
                return {
                    ...prevFormData,
                    [fieldKey]: wrapped,
                };
                }
        
                return prevFormData;
            } else {
                return {
                ...prevFormData,
                [fieldKey]: isEditorEmpty(value) ? '' : value,
                };
            }
            });
        
            return {
            ...prev,
            [field]: switchingToRich,
            };
        });
    };
    
    
    const isEditorEmpty = (html) => {
        const cleaned = html.trim();
        return (
            cleaned === '' ||
            cleaned === '<p><br></p>' ||
            cleaned === '<p></p>' ||
            cleaned === '<br>' ||
            cleaned === '<p><br></p><p><br></p>'
        );
    };
    
    
    
    const onEditorChange = (field, value) => {
        const cleanedValue = isEditorEmpty(value) ? '' : value;
        setFormData(prev => ({ ...prev, [field]: cleanedValue }));
    };
    
    const birthDateRef = useRef(null);
    const DOBRef = useRef(null);
    const recentGradDateRef = useRef(null);
    const DateofAppRef = useRef(null);
    const DateofAcceptRef = useRef(null);
    const DateofSigningRef = useRef(null);
    const DateofAssignRef = useRef(null);
    const TierStatusDateRef = useRef(null);
    const[success,setSuccess] = useState({});
    const [statelist, setStateList] = useState({});
    const [countrieslist, setCountriesList] = useState({});
    const[salespersonList, setSalespersonList] = useState({});
    const [file, setFile] = useState({});
    const domain_url = configData.DOMAIN_URL;
    const app_url = configData.APP_URL;
    const loggedin_uid = localStorage.getItem('drupal_uid');
    const [showPasswordSuggestions, setShowPasswordSuggestions] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [swalProps, setSwalProps] = useState({});
    const[rolesList, setRolesList] = useState({});
    const [selectedRoles, setSelectedRoles] = useState(['2']);
    const [selected, setSelected] = useState([]);
    const [courseList, setCourseList] = useState([]);
    const [sortFlagOptions, setSortFlagOptions] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [pages, setPages] = useState([]);

    const [previewImageUrl, setPreviewImageUrl] = useState("/basic/web/images/notavailable.jpg");
    const [showDeletePictureCheckbox, setShowDeletePictureCheckbox] = useState(false);
    
    const [selectedAgentImage, setSelectedAgentImage] = useState(null);
    const [tempAgentImage, setTempAgentImage] = useState(null);
    const [agentImageRemoved, setAgentImageRemoved] = useState(false);
    const [selectedScoutImage, setSelectedScoutImage] = useState(null);
    const [tempScoutImage, setTempScoutImage] = useState(null);
    const [scoutImageRemoved, setScoutImageRemoved] = useState(false); 
    const [selectedMentorImage, setSelectedMentorImage] = useState(null);
    const [tempMentorImage, setTempMentorImage] = useState(null);
    const [mentorImageRemoved, setMentorImageRemoved] = useState(false);
    const [agentImageError, setAgentImageError] = useState(null);
    const [scoutImageError, setScoutImageError] = useState(null);
    const [mentorImageError, setMentorImageError] = useState(null);

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [fileInputKey, setFileInputKey] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    const [agentuploadFiles, setAgentUploadedFiles] = useState([]);

    const [scoutSelectedFiles, setScoutSelectedFiles] = useState([]);
    const [scoutUploadedFiles, setScoutUploadedFiles] = useState([]);
    const [scoutFileInputKey, setScoutFileInputKey] = useState(0);
    const [scoutErrorMessage, setScoutErrorMessage] = useState('');
    const [scoutcontractuploadFiles, setScoutContractUploadedFiles] = useState([]);

    const [athleteSelectedFiles, setAthleteSelectedFiles] = useState([]);
    const [athleteUploadedFiles, setAthleteUploadedFiles] = useState([]);
    const [athleteFileInputKey, setAthleteFileInputKey] = useState(0);
    const [athleteErrorMessage, setAthleteErrorMessage] = useState('');
    const [athletecontractuploadFiles, setAthleteContractUploadedFiles] = useState([]);

    const [athleteType, setAthleteType] = useState({});
    const [athletesportList, setAthleteSportList] = useState({});

    const [leadList, setLeadList] = useState({});
    const[sportsfocus, setSportsFocus] = useState({});
    const[SportsyouWorked, setSportsYouWorked] = useState({});
    const[dreamJob, setDreamJob] = useState({});
    const[specialcertificatelist, setAgentSpecialCertificateList] = useState({});
    const[degreesList, setDegreeList] = useState({});
    const[agentlist, setAgentList] = useState([]);
    const[docTalkList, setDocTalkList] = useState({});

    const [agentsportList, setAgentSportList] = useState('');
    const [scoutsportList, setScoutSportList] = useState({});

    const[userDocTalkAsset, setUserDocTalkAsset] = useState({});
    const[userLeadAsset, setUserLeadAsset] = useState({});
    const[userEventAsset, setUserEventAsset] = useState({});
    const[userAthleteAsset, setUserAthleteAsset] = useState([]);

    const formatTime = (date = new Date(), withSeconds = true) => {
        const pad = (n) => String(n).padStart(2, "0");
        const hh = pad(date.getHours());
        const mm = pad(date.getMinutes());
        const ss = pad(date.getSeconds());
        return withSeconds ? `${hh}:${mm}:${ss}` : `${hh}:${mm}`;
    };
    const [initialTime, setInitialTime] = useState("");      // For HH:MM:SS
    const [initialDobTime, setInitialDobTime] = useState(""); // For HH:MM
    const [inputValue, setInputValue] = useState("");       // if you need for controlled input

    useEffect(() => {
    const now = new Date();
    setInitialTime(formatTime(now, true));   // HH:MM:SS
    setInitialDobTime(formatTime(now, false)); // HH:MM
    setInputValue(formatTime(now, true));   // Default input with HH:MM:SS
    }, []);

    const [toggles, setToggles] = useState({
        // timeZone: true,
        appliedCoursesList: false,
        sortFlagList: false,
        docTalkList: false,
        agentFields: true,
        scoutFields: true,
        mentorFields: true,
        applicationFields: true,
        athleteFields: true,
        eventAttendee: true,
        leadFields: true,
        account_admin:true,
        background_career:true,
        social_links:true,
        contact_address:true,
        miscellaneous:true,
        application_systemdata:true,
        education:true,
    });

    const handleToggle = (key) => {
        setToggles((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleSportsyouWorkedChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, field_sports_you_worked: selectedValues }));
    };
    const handleDreamJobChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, field_your_dream_job: selectedValues }));
    };

    const handleAddPlacement = () => {
        setFormData((prev) => ({
        ...prev,
        placements: [...prev.placements, { page: '', order: '1' }],
        }));
    };

    const handleDeletePlacement = (index) => {
        const updated = formData.placements.filter((_, i) => i !== index);
        setFormData((prev) => ({ ...prev, placements: updated }));
    };

    const handlePlacementChange = (index, field, value) => {
        const updated = [...formData.placements];
        updated[index][field] = value;
        setFormData((prev) => ({ ...prev, placements: updated }));
    };

    const handleSportsFocusChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, field_sports_focus: selectedValues }));
    };
    const handleAgentRepresentChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, field_agents_represented_by: selectedValues }));
    };
    const handleAthleteSportChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, field_athlete_sports: selectedValues }));
    };
    const getCurrentDateFormatted = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
    };
    const currentFormattedDate = getCurrentDateFormatted();

    const getCurrentBDateFormatted = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    };
    const currentFormattedBDate = getCurrentBDateFormatted();  
    
const parseDate = (dateString) => {
    if (!dateString) return null;

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        const [mm, dd, yyyy] = dateString.split('/');
        dateString = `${yyyy}-${mm}-${dd}`;
    }
    const dateObj = new Date(dateString);
    return isNaN(dateObj) ? null : dateObj;
};

const safeParseDate = (dateString) => {
    if (!dateString) return null;

    // Already Date object
    if (dateString instanceof Date && !isNaN(dateString)) {
        return dateString;
    }

    // Convert "yyyy-MM-dd HH:mm:ss"
    if (typeof dateString === "string") {
        dateString = dateString.trim();

        // Convert space to T for Safari
        if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(dateString)) {
            dateString = dateString.replace(" ", "T");
        }

        // Convert MM/DD/YYYY
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
            const [mm, dd, yyyy] = dateString.split("/");
            dateString = `${yyyy}-${mm}-${dd}`;
        }
    }

    const parsed = new Date(dateString);

    return isNaN(parsed.getTime()) ? null : parsed;
};

// useEffect(() => {
//     const processData = () => {
//     if (userLeadAsset.length > 0) {
//       userLeadAsset.forEach(item => {
//         if (item['key'] === 'field_call_back' && item['value']) {
//             const dateString = item['value']; 
//             const [date, time] = dateString.split(" "); 
//             const [year, month, day] = date.split("-"); 
//             const [hour, minute, second] = time.split(":");

//             setFormData(prev => ({ 
//                 ...prev, 
//                 field_call_back_year: year, 
//                 field_call_back_month: month, 
//                 field_call_back_day: day, 
//                 field_call_back_hour: hour, 
//                 field_call_back_minute: minute, 
//                 field_call_back_second: second
//             }));
//         }
//         else {       
//           setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
//         }
//       });
//     }
//     // if (userMentorAssets.length > 0) {
//     //   userMentorAssets.forEach(item => {
//     //     setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
        
//     //   });
//     // }
//     if (userEventAsset.length > 0) {
//         userEventAsset.forEach(item => {
       
//             setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
            
//         });
//     }
//     if (userDocTalkAsset.length > 0) {
//         userDocTalkAsset.forEach(item => {
//             setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
//         });
//     }
//     };

//   const promises = [
//     retrieveUserDetails(),
//     getapplicationdetails(),
//     retrieveCountriesList(),
//     retrieveStateList(),
//     getsalespersonlist(),
//     getroleslist(),
//     getplacementlist(),
//     getagentsportslist(),
//     getscoutsportslist(),
//     getfieldslist()
//   ];

//   processData(); // Sync processing
//   //console.log(agentuploadFiles.length + "haiiii");

//   Promise.all(promises)
//     .then(() => {
//       setIsLoading(false);
//     })
//     .catch(error => {
//       console.error(error);
//       // Handle error
//     });
    
//   },[]);

useEffect(() => {

  const promises = [
    retrieveUserDetails(),
    getapplicationdetails(),
    retrieveCountriesList(),
    retrieveStateList(),
    getsalespersonlist(),
    getroleslist(),
    getplacementlist(),
    getagentsportslist(),
    getscoutsportslist(),
    getfieldslist()
  ];

  Promise.all(promises)
    .then(() => {
      setIsLoading(false);
    })
    .catch((error) => {
      console.error(error);
    });

}, []);

useEffect(() => {

  const updatedData = {};

  // Lead assets
  if (userLeadAsset?.length > 0) {

    userLeadAsset.forEach((item) => {

      if (item.key === "field_call_back" && item.value) {

        const [date, time] = item.value.split(" ");

        const [year, month, day] = date.split("-");

        const [hour, minute, second] = time.split(":");

        updatedData.field_call_back_year = year;
        updatedData.field_call_back_month = month;
        updatedData.field_call_back_day = day;
        updatedData.field_call_back_hour = hour;
        updatedData.field_call_back_minute = minute;
        updatedData.field_call_back_second = second;

      } else if (item.key === "field_lead_type" && item.value) {

        updatedData.field_lead_type = item.value.map(String);

      } else {

        updatedData[item.key] = item.value;

      }

    });
  }

  // Doc talk assets
  if (userDocTalkAsset?.length > 0) {

    userDocTalkAsset.forEach((item) => {
      updatedData[item.key] = item.value;
    });

  }

  // Event assets
  if (userEventAsset?.length > 0) {

    userEventAsset.forEach((item) => {
      updatedData[item.key] = item.value;
    });

  }

  // Athlete assets
  if (userAthleteAsset?.length > 0) {

    userAthleteAsset.forEach((item) => {
      updatedData[item.key] = item.value;
    });

  }

  // console.log("FINAL updatedData", updatedData);

  setFormData((prev) => ({
    ...prev,
    ...updatedData,
  }));

}, [userLeadAsset, userDocTalkAsset, userEventAsset, userAthleteAsset]);


  async function retrieveUserDetails() {
    if(uid) {
       try {
        
    const response = await fetch(
      app_url+'editprofile/getusereditdetails?uid='+uid,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
    //   if(responsedata.data.result) {
    //     Object.keys(responsedata.data.result).forEach(function(key) {
          
    //       setFormData(prevState => ({
    //         ...prevState,
    //         [key]: responsedata.data.result[key]
    //       }));
       
    //     });
      
    // }
    if (responsedata.data.result) {
        setOriginalUserName(responsedata.data.result.userName || "");
        setFormData(prevState => {
            const updated = { ...prevState };

            Object.keys(responsedata.data.result).forEach(key => {
            const value = responsedata.data.result[key];

            if (key === 'field_recent_graduation_date' && value) {
                updated[key] = parseDate(value);
            } else {
                updated[key] = value ?? '';
            }
            });

            return updated;
        });
    }
    if(responsedata.data.sortflags) {
     setSortFlagOptions(responsedata.data.sortflags);
    }
     if(responsedata.data.courses) {
     setCourseList(responsedata.data.courses);
    }
    console.log(formData);
    }
    } catch (error) {
        console.error(error);
      }finally {
             // Set loading to false after fetch completes (success or error)
          }
  }
  }

 async function getapplicationdetails() { 
    
    if(uid!='' || username!='') {
      try {
        setIsLoading(true);
    const response = await fetch(
      app_url+'viewprofile/getapplicationprofiledetails?uid='+uid+'&username='+username,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
      setUserDocTalkAsset(responsedata.data.user_doctalk_assets);
      setUserLeadAsset(responsedata.data.user_lead_assets);
      setUserEventAsset(responsedata.data.user_event_attendee_assets);
      setUserAthleteAsset(responsedata.data.user_athlete_assets);
    }
    }  catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  }
  }

  async function retrieveStateList() {
     try {
       
    const statelistresponse = await fetch(app_url + 'smwwstates/getstatelist', {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const statelistdata = await statelistresponse.json();
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      statelist[key] = statelistdata.data.result[key];
    });
    setStateList(statelist);
   } catch (error) {
        console.error(error);
      }finally {
           
          }
  }
async function getagentsportslist() {
    
         try {
            const response = await fetch(
                app_url+'smwwagency/agentsports',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
                setAgentSportList(responsedata.data);
               
            } 
        } catch (err) {
            
         }
        
  }
 
  async function getscoutsportslist() {
    
         try {
            const response = await fetch(
                app_url+'smwwscout/scoutsports',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
                setScoutSportList(responsedata.data);
               
            } 
        } catch (err) {
            
         }
        
  }
   async function getfieldslist() {
    
         try {
            const response = await fetch(
                app_url+'smwwfieldlist/getfieldlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
               setAthleteType(responsedata.data.athletetype);
               setAthleteSportList(responsedata.data.athletesport);
               setLeadList(responsedata.data.leadtype);
               setSportsFocus(responsedata.data.sportsfocus);
               setSportsYouWorked(responsedata.data.sportsworked);
               setDreamJob(responsedata.data.dreamjob);
               setAgentSpecialCertificateList(responsedata.data.agentspecialcertifications);
               setDegreeList(responsedata.data.degreeslist);
               setAgentList(responsedata.data.agentlist);
               setDocTalkList(responsedata.data.doctalk);
            } 
        } catch (err) {
            
         }
        
  }
  async function retrieveCountriesList() {
     try {
      
    const countrieslistresponse = await fetch(app_url + 'smwwcountries/getcountrieslist', {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const countrieslistdata = await countrieslistresponse.json();
    const countrieslist = {};
    Object.keys(countrieslistdata.data.result).forEach(function(key) {
      countrieslist[key] = countrieslistdata.data.result[key];
    });
    setCountriesList(countrieslist);
    } catch (error) {
        console.error(error);
      }finally {
           
          }
  }
   async function getsalespersonlist() {
    
        try {
      
            const response = await fetch(
                app_url+'user/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (error) {
        console.error(error);
      }finally {
            
          }
        
  }

 
  async function getroleslist() {
    
         try {
         const response = await fetch(
                 app_url+'user/getfullroleslist',
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setRolesList(responsedata.data.result);
            }
       
            
        } catch (error) {
        console.error(error);
      }finally {
           
          }
        
  }
  async function getplacementlist() {
    
         try {
            const response = await fetch(
                app_url+'node/getnodepages',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setPages(responsedata.data.result);
               
            } 
        } catch (err) {
            
        }
        
  }

    const isValidBasicPhone = (phone) => {
        const cleaned = phone.replace(/\D/g, ''); // Remove non-digit characters
        return cleaned.length >= 7 && cleaned.length <= 15;
    };
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const validateForm = (data) => {
        const errors = [];
        const newFieldErrors = { userName: false , mail: false, field_smww_email: false, field_realemail: false }; 
        if (!data.mail.trim()) {      
            errors.push("E-mail address field is required.");
            newFieldErrors.mail = true;
        }
        // --- Email format check ---
        else if (!isEmail.test(data.mail.trim())) {
            errors.push("Invalid e-mail address format.");
            newFieldErrors.mail = true;
        }
        // --- Agency-scout email ---
        if (data.field_smww_email && data.field_smww_email.trim() !== "") {
            if (!isEmail.test(data.field_smww_email.trim())) {
                errors.push("Invalid Agency-scout e-mail address format.");
                newFieldErrors.field_smww_email = true;
            }
        }

        // --- Real email ---
        if (data.field_realemail && data.field_realemail.trim() !== "") {
            if (!isEmail.test(data.field_realemail.trim())) {
                errors.push("Invalid Real e-mail address format.");
                newFieldErrors.field_realemail = true;
            }
        }
        //high school garduation year
        if (data.field_hs_grad_year) {
            if (!/^\d+$/.test(data.field_hs_grad_year)) {
                errors.push("High School Graduation Year must contain numbers only.");
                newFieldErrors.field_hs_grad_year = true;
            }
        }

        if (userRoles.includes(configData.ROLE_AGENT) || userRoles.includes(configData.ROLE_SCOUT) || userRoles.includes(configData.ROLE_GLOBAL_AMBASSADOR)) {
             if (!data.field_continentid) {
                errors.push("Continent is required.");
                    newFieldErrors.field_continentid = true;
            }
        }
            //scout slug
             if (data.field_scout_slug) {
            if (!data.field_scout_slug?.trim()) {      
            errors.push("Scout Slug field is required.");
                newFieldErrors.field_scout_slug = true;
            }
         }
            //agent slug
            if (data.field_agent_slug) {
            if (!data.field_agent_slug?.trim()) {      
            errors.push("Agent Slug field is required.");
                newFieldErrors.field_agent_slug = true;
            }
        }
            //ambassador slug
             if (data.field_ambassador_slug) {
            if (!data.field_ambassador_slug?.trim()) {      
            errors.push("Ambassador Slug field is required.");
                newFieldErrors.field_ambassador_slug = true;
            }
         }
           // Age validation
  if (data.field_age) {
  if (!/^\d+$/.test(String(data.field_age).trim())) {
    errors.push("Age must be an integer.");
    newFieldErrors.field_age = true;
  }
}


  // Scout Rank validation
  if (data.field_scout_rank) {
 if (!/^\d+$/.test(String(data.field_scout_rank).trim())) {
    errors.push("Scout Rank must be an integer.");
    newFieldErrors.field_scout_rank = true;
  }}
        // Username
        // if (!data.userName || data.userName.trim() === '') {
        //     errors.push("Username field is required.");
        //     newFieldErrors.userName = true;
        // } else {
        //     if (data.userName.startsWith(' ')) {
        //     errors.push("The username cannot begin with a space.");
        //     newFieldErrors.userName = true;
        //     }
        
        // }
         // USERNAME
        const isUserEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        // const isName = /^[a-zA-Z][a-zA-Z\s.\-']*$/;

        if (!data.userName || data.userName.trim() === '') {
            errors.push("Username field is required.");
            newFieldErrors.userName = true;
        } else {
            if (data.userName.startsWith(' ')) {
            errors.push("The username cannot begin with a space.");
            newFieldErrors.userName = true;
            }

            if (data.userName !== originalUserName) {
            if (!isUserEmail.test(data.userName)) {
                errors.push("Username must be a valid email address.");
                newFieldErrors.userName = true;
            }
            }
        }

        if (data.userName !== originalUserName) {
            if (
                data.mail &&
                data.userName &&
                isEmail.test(data.mail) &&
                isUserEmail.test(data.userName) &&
                data.mail !== data.userName
            ) {
                errors.push("Username and E-mail address must be the same.");
                newFieldErrors.mail = true;
                newFieldErrors.userName = true;
            }
        }
        //  set just the userName field error tracking
        setFieldErrors(newFieldErrors);

        if (data.password) {
            if(loggedin_uid == uid) {
                if(!data.current_pass) {
                    errors.push("Please fill in Current Password.");
                }
            }
            if(!data.confirmPassword) {
                errors.push("Please fill in Confirm Password.");
            }
            if(data.password != data.confirmPassword) {
                errors.push("The specified passwords do not match.");
            }
        }
        if(data.field_linkedin_url !== null) {
            if(data.field_linkedin_url.trim() !== '') {
                var linkedinurl = data.field_linkedin_url.toLowerCase();
                if (linkedinurl.includes("linkedin.com/") === false) {
                    errors.push('Please enter a valid LinkedIn URL');  
                }
            }
        }
        // Instagram
        if (data.field_instagram_url && data.field_instagram_url.trim() !== '') {
            let url = data.field_instagram_url.toLowerCase();
            if (!url.includes("instagram.com/")) {
            errors.push("Please enter a valid Instagram URL");
            }
        }

        // Facebook
        if (data.field_facebook_url && data.field_facebook_url.trim() !== '') {
            let url = data.field_facebook_url.toLowerCase();
            if (!url.includes("facebook.com/")) {
            errors.push("Please enter a valid Facebook URL");
            }
        }

        // Twitter (X)
        if (data.field_twitter_url && data.field_twitter_url.trim() !== '') {
            let url = data.field_twitter_url.toLowerCase();
            if (!url.includes("twitter.com/") && !url.includes("x.com/")) {
            errors.push("Please enter a valid Twitter URL");
            }
        }

        // YouTube
        if (data.field_user_youtube_url && data.field_user_youtube_url.trim() !== '') {
            let url = data.field_user_youtube_url.toLowerCase();
            if (!url.includes("youtube.com/") && !url.includes("youtu.be/")) {
            errors.push("Please enter a valid YouTube URL");
            }
        }

        // TikTok
        if (data.field_tiktok_url && data.field_tiktok_url.trim() !== '') {
            let url = data.field_tiktok_url.toLowerCase();
            if (!url.includes("tiktok.com/")) {
            errors.push("Please enter a valid TikTok URL");
            }
        }
    
        if (data.field_phone) {
            if(data.field_phone.trim()) {
                if (!isValidBasicPhone(data.field_phone)) {
                    errors.push('Invalid Primary Phone Number');
                }
            }
        }
        if (data.field_secondary_phone) {
            if(data.field_secondary_phone.trim()) {
                if (!isValidBasicPhone(data.field_secondary_phone)) {
                    errors.push('Invalid Secondary Phone Number');
                }
        }
        }
        if (data.field_night_phone) {
            if(data.field_night_phone.trim()) {
                if (!isValidBasicPhone(data.field_night_phone)) {
                    errors.push('Invalid Night Phone Number');
                }
            }
        }
        const callbackFields = {
            month: data.field_call_back_month,
            day: data.field_call_back_day,
            year: data.field_call_back_year,
            hour: data.field_call_back_hour,
            minute: data.field_call_back_minute,
            second: data.field_call_back_second
        };
        const isAnySelected = Object.values(callbackFields).some(
            value => value !== '' && value !== null && value !== undefined
        );
        if (isAnySelected) {
            const missingFields = Object.entries(callbackFields)
                .filter(([_, value]) => !value)
                .map(([field]) => field);

            if (missingFields.length) {
                errors.push(
                    <div>
                        The value input for field <em>Call Back</em> is invalid.
                        <br />
                        {missingFields.length === 1
                        ? `The following field is missing: ${missingFields[0]}`
                        : `The following fields are missing: ${missingFields.join(', ')}`}
                    </div>
                );
            }
        }
        return errors; 
    } 
  

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === "checkbox") {
            const arrayFields = [
                "applied_courses",
                "sort_flags",
                "field_lead_type",
                "field_agent_sports",
                "field_agent_certifications",
                "field_special_certifications",
                "field_scout_sport",
                "field_cuc_degrees",
                "field_doc_talk",
                "field_mentor_sports"
            ];

            if (arrayFields.includes(name)) {
            setFormData((prev) => {
                let current = [...(prev[name] || [])].map(String);
                const stringValue = String(value);

                if (checked && !current.includes(stringValue)) {
                current.push(stringValue);
                } else if (!checked) {
                current = current.filter((item) => item !== stringValue);
                }

                return {
                ...prev,
                [name]: current,
                };
            });

            return;
            }

            // Boolean fields
            setFormData((prev) => ({
            ...prev,
            [name]: checked ? 1 : 0,
            }));

            return;
        }

        // Non-checkbox fields
        if (name === "password") {
            setPasswordStrength(calculatePasswordStrength(value));
        }

        setFormData((prev) => {
            const updated = { ...prev };

            if (name.includes(".")) {
            const [parent, child] = name.split(".");
            let finalValue = value;

            // if (name === "field_dob.time" && value?.length >= 5) {
            //     finalValue = value.substring(0, 5);
            // }

            updated[parent] = {
                ...prev[parent],
                [child]: finalValue,
            };
            } else {
            updated[name] = value;
            }

            return updated;
        });
    };
    const handleRolesChange = (e) => {
        const { value, checked } = e.target;
        const isChecked = checked;
        if(isChecked){
            setFormData(prevState => ({ 
            ...prevState, 
            roles: [...prevState.roles, Number(value)] 
            }));
        } else {
            setFormData(prevState => {
            const updatedRoles = prevState.roles.filter(role => role !== Number(value));
            return { ...prevState, roles: updatedRoles };
            });
        }
    };

    // const handleDateChange = (date) => {
    //     const formattedDate = format(date, "yyyy-MM-dd "); // Example: 2025-06-21 11:03:00
    //     setFormData(prev => ({
    //         ...prev,
    //         field_birthday: formattedDate
    //     }));
    // }

    const handleDateChange = (date, field) => {
    if (!date) {
        setFormData(prev => ({
            ...prev,
            [field]: ''
        }));
    } else {
        // const formattedGraduationDate = format(date, "yyyy-MM-dd"); 
        const formattedDate = format(date, "yyyy-MM-dd "); // Example: 2025-06-21 11:03:00
        setFormData(prev => ({
            ...prev,
            [field]: formattedDate,
            // field_recent_graduation_date: formattedGraduationDate
        }));
    }
    }

    const calculatePasswordStrength = (password) => {
        if (password.length < 6) return 'Weak';
        if (password.length >= 6 && /[A-Z]/.test(password) && /[a-z]/.test(password) && /\d/.test(password) && /[^A-Za-z0-9]/.test(password)) {
        return 'Strong';
        }
        return 'Fair';
    };

    const [rules, setRules] = useState({
        length: false,
        lowercase: false,
        uppercase: false,
        number: false,
        special: false
    });

    const validatePassword = (password) => {
        setRules({
        length: password.length >= 6,
        lowercase: /[a-z]/.test(password),
        uppercase: /[A-Z]/.test(password),
        number: /\d/.test(password),
        special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        });
    };

    const allRulesPassed = Object.values(rules).every(Boolean);

const fileInputRef = useRef();

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const errors = [];

        if (!file.type.startsWith("image/")) {
            errors.push("Only files with the following extensions are allowed: png, gif, jpg, jpeg.");
            e.target.value = null;
            showErrors(errors);
            return;
        }

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const { width, height } = img;

            if (width < 100 || height < 100) {
            errors.push("Image is too small. Minimum size is 100×100 pixels.");
            }

            if (width > 1000 || height > 1000) {
            errors.push("Image is too large. Maximum size is 1000×1000 pixels.");
            }

            // URL.revokeObjectURL(objectUrl);

            if (errors.length > 0) {
            e.target.value = null;
            showErrors(errors);
            if (fileInputRef.current) fileInputRef.current.value = "";
            return;
            }

            // Valid file: update state
            setFile(file);
            setPreviewImageUrl(objectUrl);
            // setShowDeletePictureCheckbox(true);

            setFormData((prev) => ({
            ...prev,
            picture: file,
            pictureDelete: false, // Reset delete checkbox if a new file is selected
            }));
        };

        img.onerror = () => {
            errors.push("Failed to load image. Please choose a valid image file.");
            e.target.value = null;
            URL.revokeObjectURL(objectUrl);
            showErrors(errors);
        };

        img.src = objectUrl;
    };

useEffect(() => {
  if (picture) {
    setPreviewImageUrl(picture);
    setShowDeletePictureCheckbox(true);
  } else {
    setPreviewImageUrl("/basic/web/images/notavailable.jpg");
  }
  console.log(formData);
}, [picture]);

    const showErrors = (errors) => {
        setError(errors); 
        setSuccess({});
        window.scrollTo(0, 0);
    };

    const handleDeleteCheckboxChange = (e) => {
        const isChecked = e.target.checked;

        setFormData((prev) => ({
            ...prev,
            pictureDelete: isChecked,
            picture: isChecked ? null : prev.picture,
        }));

        if (isChecked) {
            setFile(null);
            setPreviewImageUrl("/basic/web/images/notavailable.jpg");
            // setShowDeletePictureCheckbox(false);
            if (fileInputRef.current) fileInputRef.current.value = "";
        }
    };

    const handleUserRoleFileChange = (e, setTempImageCallback, setImageRemovedCallback, setErrorCallback) => {
        const file = e.target.files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxSize = 128 * 1024 * 1024; // 128 MB
        const errors = [];

        if (!validTypes.includes(file.type)) {
            errors.push('Allowed file types: png, gif, jpg, jpeg.');
        }

        if (file.size > maxSize) {
            errors.push('File must be less than 128 MB.');
        }

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const { width, height } = img;

            if (width < 100 || height < 100 || width > 1000 || height > 1000) {
                errors.push('Image size must be 100×100 px or 1000×1000 px.');
            }

            URL.revokeObjectURL(objectUrl);

            if (errors.length > 0) {
                setErrorCallback?.(errors.join('<br />'));
                e.target.value = '';
                setTempImageCallback(null);
            } else {
                setTempImageCallback(file);      
                setErrorCallback?.(null);         
                setImageRemovedCallback?.(false);
            }
        };

        img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            setErrorCallback?.('Failed to load image. Please choose a valid image file.');
            e.target.value = '';
            setTempImageCallback(null);
        };

        img.src = objectUrl;
    };

    const handleUserRoleImageUpload = (tempImage, setSelectedImageCallback, setTempImageCallback) => {
        if (!tempImage) return;

        setSelectedImageCallback(tempImage);
        setTempImageCallback(null); // Clear temp after "upload"
    };

    const removeImage = (setImageStateCallback, setImageRemovedCallback, setErrorCallback) => {
        setImageStateCallback(null);
        setImageRemovedCallback?.(true);
        setErrorCallback?.(null);
    };

    const handleDelete = async (e) => {
        e.preventDefault(); 
        const confirmed = window.confirm('Are you sure?');
        if (confirmed) {
            const response = await fetch(app_url+'user/deleteuser', {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
                alert("Successfully Deleted");
                navigate('/manage/people');
            }  
        }  
    };

    const handleCancel = async (e) => {
        e.preventDefault();
        const confirmed = window.confirm('Are you sure?');

        if (confirmed) {
        // User clicked "OK", proceed with the action
        window.location.href = "/user/"+uid;
        
        // Add your deletion logic here
        } else {
        // User clicked "Cancel"
        
        }
    }
    
//   // handler for timezone select
//   const handleTimezoneChange = (e) => {
//     const parsed = parseTimezone(e.currentTarget.value);
//     setFormData((prev) => ({ ...prev, timezone: parsed.value })); 
//   };
//   // Add current date, day, and time to each option
//   const optionsWithTime = useMemo(() => {
//     return baseOptions.map((option) => {
//       const now = new Date();
      
//       // Format date, day, and time in the target timezone
//       const formatted = new Intl.DateTimeFormat("en-US", {
//         weekday: "long",  // Mon, Tue, ...
//         year: "numeric",
//         month: "long",    // Jan, Feb, ...
//         day: "2-digit",
//         hour: "2-digit",
//         minute: "2-digit",
//         timeZone: option.value,
//       }).format(now);

//       return {
//         ...option,
//         label: `${option.label} - ${formatted}`
//       };
//     });
//   }, [baseOptions]);

//   // Add current date/time in the label for display only
//   const optionsWithTime = useMemo(() => {
//     return baseOptions.map((option) => {

//       const now = new Date();
//       const formatted = new Intl.DateTimeFormat("en-US", {
//         weekday: "short",
//         year: "numeric",
//         month: "short",
//         day: "2-digit",
//         hour: "2-digit",
//         minute: "2-digit",
//         timeZone: option.value,
//       }).format(now);

//       return {
//         ...option,
//         label: `${option.label}: ${formatted}`, // display current time
//       };
//     });
//   }, [baseOptions]);

// const handleTimezoneChange = (e) => {
//   const value = e.currentTarget.value; // the timezone string
//   const parsed = parseTimezone(value); // full object

//   const now = new Date();
//   const formatted = new Intl.DateTimeFormat("en-US", {
//     weekday: "long",
//     year: "numeric",
//     month: "long",
//     day: "2-digit",
//     hour: "2-digit",
//     minute: "2-digit",
//     timeZone: parsed.value,
//   }).format(now);
//   console.log(parsed);
//   setFormData({
//     ...formData,
//     timezone: {
//       ...parsed,
//       currentDateTime: formatted,
//     },
//   });
// };

// const handleTimezoneChange = (e) => {
//   const value = e.currentTarget.value; // timezone string
//   setFormData({
//     ...formData,
//     timezone: value, 
//   });
//   console.log("Selected timezone value:", value);
// };

const handleSubmit = async event => {
  event.preventDefault();
  const newErrors = validateForm(formData);
  setError(newErrors);
  setSuccess({});
  if (Object.keys(newErrors).length === 0) {
    let finalFormData = { ...formData };

    const isValidSalesperson = salespersonList.some(
        (person) => String(person.uid) === String(finalFormData.field_user_assignment)
    );

    // If a value is selected but it's not in the valid list, reset to empty
    if (finalFormData.field_user_assignment && !isValidSalesperson) {
        finalFormData.field_user_assignment = '';
    }
    // Helper function to format date and time fields
    const formatDate = (date) => {
        if (!date) return '';
        if (typeof date === 'string') {
            date = date.trim();
        }
        if (date instanceof Date) {
            if (isNaN(date.getTime())) {
                return '';
            }
            return format(date, 'yyyy-MM-dd');
        }
        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
            return date;
        }
        if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
            const [dd, mm, yyyy] = date.split('-');
            return `${yyyy}-${mm}-${dd}`;
        }
        throw new Error(`Invalid date format: ${date}`);
    };

    const formatDateTimeField = (field) => {
        const fieldData = finalFormData[field];
        if (!fieldData?.date) {
            finalFormData[field] = '';
            return;
        }
        let formattedValue = formatDate(fieldData.date);
        if (fieldData.time) {
            formattedValue += `T${fieldData.time}`;
        }
        finalFormData[field] = formattedValue;
    };

    // Apply formatting to all relevant fields
    // formatDateTimeField('field_date_of_signing');
    // formatDateTimeField('field_date_of_assignment');
    // formatDateTimeField('field_dob');
    // formatDateTimeField('field_tier_status_date');

    finalFormData.field_recent_graduation_date =
    finalFormData.field_recent_graduation_date
    ? formatDate(finalFormData.field_recent_graduation_date)
    : '';

    setFormData(prevState => ({
      ...prevState,
      button_name: "Saving..."
    }));

    const postData = new FormData();
    postData.append("file", file);
    // postData.append("field_agent_photo", selectedAgentImage);
    //  postData.append("field_scout_photo", selectedScoutImage);
    //  postData.append("field_mentor_photo", selectedMentorImage);
    // uploadedFiles.forEach(file => postData.append('agentcontractfiles[]', file));
    // scoutUploadedFiles.forEach(file => postData.append('scoutcontractfiles[]', file));
    // athleteUploadedFiles.forEach(file => postData.append('athletecontractfiles[]', file)); 
    postData.append("formData", JSON.stringify(finalFormData));

    const response = await fetch(app_url + "editprofile/putusereditdetails", {
      method: "POST",
      body: postData,
    });

    const data = await response.json();

    if (data.data.msg === "Success") {
        retrieveUserDetails();
        getapplicationdetails();
        if (loggedin_uid == uid) {
            setSuccess(data.data.result);} 
        else {
          navigate(`/users/${data.data.user_slug}`, {
            state: {
                userId: uid,
            result: data.data.result,
            }
        });}
        setFormData(prevState => ({
            ...prevState,
            button_name: "Save"
        }));
        window.scrollTo(0, 0);
    } else {
      setError(data.data.result);
      setSuccess({});
      setFormData(prevState => ({
        ...prevState,
        button_name: "Save"
      }));
      window.scrollTo(0, 0);
    }
  } else {
    window.scrollTo(0, 0);
  }
};

    const validTypes = [
        'text/plain',
        'image/png',
        'image/jpeg',
        'image/jpg',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
    ];

    const maxSize = 128 * 1024 * 1024;

// const getFileIcon = (fileName) => {
//   if (!fileName || typeof fileName !== 'string') {
//     return '/basic/web/images/image-x-generic.png';
//   }

//   const extension = fileName.split('.').pop().toLowerCase();

//   switch (extension) {
//     case 'txt': return '/basic/web/images/text-plain.png';
//     case 'pdf': return '/basic/web/images/application-pdf.png';
//     case 'docx': return '/basic/web/images/x-office-document.png';
//     case 'jpg':
//     case 'jpeg':
//     case 'png': return '/basic/web/images/image-x-generic.png';
//     default: return '/basic/web/images/image-x-generic.png';
//   }
// };

    // const handleFileInputChange = (e, setSelected, setError, setKey) => {
    //     const files = Array.from(e.target.files);

    //     const validFiles = [];
    //     const invalidFiles = [];

    //     files.forEach(file => {
    //         const isValidType = validTypes.includes(file.type);
    //         const isValidSize = file.size <= maxSize;

    //         if (isValidType && isValidSize) {
    //         validFiles.push(file);
    //         } else {
    //         invalidFiles.push(file);
    //         }
    //     });

    //     if (invalidFiles.length > 0) {
    //         const names = invalidFiles.map(f => f.name).join(', ');
    //         setError(
    //         `The selected file${invalidFiles.length > 1 ? 's' : ''} ${names} cannot be uploaded. 
    //         Only files with the following extensions are allowed: txt, png, jpg, jpeg, pdf, docx.`
    //         );
    //         setKey(prev => prev + 1); // reset input
    //         setSelected([]);          // clear selection
    //     } else {
    //         setError('');
    //         setSelected(validFiles);
    //     }
    // };
    // const handleUpload = (selectedFiles, setUploaded, setError, setSelected, setKey) => {
    //     const newFiles = selectedFiles.filter(file => {
    //         const isValidType = validTypes.includes(file.type);
    //         const isValidSize = file.size <= maxSize;
    //         return isValidType && isValidSize;
    //     });

    //     setUploaded(prev => [...prev, ...newFiles]);
    //     setError('');
    //     setSelected([]);
    //     setKey(prev => prev + 1); // reset input
    // };
    // const removeFile = (index, setUploaded) => {
    //     setUploaded(prev => prev.filter((_, i) => i !== index));
    // };
// const removeAgentContractFile = (index,removed_fid) => {
//         setAgentUploadedFiles(prev => prev.filter((_, i) => i !== index));
//          setFormData(prev => ({
//     ...prev,
//     removed_agent_contract_fids: [...(prev.removed_fids || []), removed_fid]
//   }));
//     }; 
//     const removeScoutContractFile = (index,removed_fid) => {
//         setScoutContractUploadedFiles(prev => prev.filter((_, i) => i !== index));
//          setFormData(prev => ({
//     ...prev,
//     removed_scout_contract_fids: [...(prev.removed_fids || []), removed_fid]
//   }));
//     }; 
//      const removeAthleteContractFile = (index,removed_fid) => {
//         setAthleteContractUploadedFiles(prev => prev.filter((_, i) => i !== index));
//          setFormData(prev => ({
//     ...prev,
//     removed_athlete_contract_fids: [...(prev.removed_fids || []), removed_fid]
//   }));
//     };

    return (
        <>
        {isLoading ? (
            <Loading />
        ) : (
        <div className="Applicantedit-profile-container">
            {error.length > 0 && (
                    <div 
                        className="set-message-error" 
                        style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, padding: "10px 10px 10px 50px"}}
                    >
                    {error.map((item, index) => {
                    return <>{item}<br /></>
                    
                    })}  
                </div>
            )}
            {success.length > 0 && (
                <>
                    {success.map((item, index) => {
                        return <>
                        <br/><div className="set-message-done">
                            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {item}
                        </div></>
                    
                    })}  
                </>
            )}
            <SweetAlert2 {...swalProps} />
            {loggedin_uid && !Number.isNaN(loggedin_uid) ? (
                <form onSubmit={handleSubmit}>          
                    <>    
                     
                    
                        
                     
                              <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("account_admin")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Account & Admin</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.account_admin ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.account_admin && (
                                <>
                                   <div className="field-row"> 
                            <span className='label'><label>Username  <span className="form-required" title="This field is required.">*</span></label></span>
                            <span className='value'>
                            <input
                                type="text"
                                name="userName"
                                value={formData.userName}
                                onChange={handleChange}
                                className={fieldErrors.userName ? 'input-error' : ''}
                            /><br/>
                            <span className="edit-profile-desc">
                                Spaces are allowed; punctuation is not allowed except for periods, hyphens, apostrophes, and underscores.
                            </span></span>
                        </div>
                        <div className="field-row">
                            <span className='label'><label htmlFor="first_name">First Name</label></span>
                             <span className='value'><input className='' type="text" id="first_name" name="firstName" value={formData.firstName} onChange={handleChange} /></span>
                        </div>

                        <div className="field-row">
                           <span className='label'> <label htmlFor="last_name">Last Name</label></span>
                             <span className='value'><input className='' type="text" id="last_name" name="lastName" value={formData.lastName} onChange={handleChange}  /> </span>
                        </div>
                        <div className="field-row">
                            <span className='label'> <label>E-mail address  <span className="form-required" title="This field is required.">*</span></label></span>
                            <span className='value'><input
                                type="email"
                                name="mail"
                                value={formData.mail}
                                onChange={handleChange}
                            /><br/>
                            <span className='edit-profile-desc'>
                                A valid e-mail address. All e-mails from the system will be sent to this address.
                                The e-mail address is not made public and will only be used if you wish to receive a new password or
                                wish to receive certain news or notifications by e-mail.
                            </span></span> 
                        </div>                        
                    <div className="field-row">
                           <span className="label"><label htmlFor="edit-field-realemail">Real Email </label></span>
                            <span className="value">
                            <input 
                                className="" 
                                type="text" 
                                id="edit-field-realemail" 
                                name="field_realemail" 
                                value={formData.field_realemail}
                                onChange={handleChange}
                                maxlength={50}
                            /></span> 
                        </div>
                        <div className="field-row">
                            <span className='label'>  <label>Password</label></span>
                             <span className='value'><div className="edit-profile-password-container">
                                <input
                                    className='edit-profile-password-box'
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData(prev => ({ ...prev, password: value }));
                                        setPasswordStrength(calculatePasswordStrength(value)); // if you're using this
                                        validatePassword(value);
                                    }}
                                    onFocus={() => setShowPasswordSuggestions(true)}
                                    onBlur={() => setShowPasswordSuggestions(false)}
                                />
                                <div className="edit-profile-password-strength">
                                    <span>Password strength: {passwordStrength}</span>
                                    <div className="strength-bar-bg">
                                        <div className={`strength-bar ${passwordStrength.toLowerCase()}`}></div>
                                    </div>
                                </div>
                            </div></span>
                        </div>
                        <div className="field-row">
                            <span className='label'> <label>Confirm password</label></span>
                            <span className='value'><div className='edit-profile-password-container'>
                            <input
                                className='edit-profile-password-box'
                                type="password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setFormData(prev => ({ ...prev, confirmPassword: value }));
                                    validatePassword(value);
                                }}
                                // onFocus={() => setShowPasswordSuggestions(true)}
                                // onBlur={() => setShowPasswordSuggestions(false)}
                            />
                            {/* Match status */}
                            {formData.confirmPassword?.length > 0 && (
                                <div className="adduser-password-confirm adduser-form-item-password" style={{fontWeight: 'normal' }}>
                                    <div>
                                        Passwords match:{' '}
                                        {formData.password === formData.confirmPassword ? (
                                            <span style={{ color: 'green' }}>Yes</span>
                                        ) : (
                                            <span style={{ color: 'red' }}>No</span>
                                        )}
                                    </div>
                                </div>
                            )}
                            </div>
                            {/* {showPasswordSuggestions && (
                                <span className="edit-profile-password-suggn">
                                <p>To make your password stronger:</p>
                                <ul>
                                    <li>Make it at least 6 characters</li>
                                    <li>Add lowercase letters</li>
                                    <li>Add uppercase letters</li>
                                    <li>Add numbers</li>
                                    <li>Add punctuation</li>
                                </ul>
                                </span>
                            )} */}
                                  {showPasswordSuggestions
                                //    && formData.password.length > 0 
                                   && !allRulesPassed && (
                                    <div className="edit-profile-password-suggn">
                                        <p>To make your password stronger:</p>
                                        <ul>
                                            {!rules.length && <li>Make it at least 6 characters</li>}
                                            {!rules.lowercase && <li>Add lowercase letters</li>}
                                            {!rules.uppercase && <li>Add uppercase letters</li>}
                                            {!rules.number && <li>Add numbers</li>}
                                            {!rules.special && <li>Add punctuation</li>}
                                        </ul>
                                    </div>
                                )}
                            <span className="edit-profile-desc">
                                To change the current user password, enter the new password in both fields.
                            </span></span>
                        </div>
                            {loggedin_uid == uid && (
                            <div className="field-row">
                                <span class='label'><label>Current Password</label></span>
                                <span class='value'>
                                <input
                                className='edit-profile-password-box'
                                type="password"
                                name="current_pass"
                                value={formData.current_pass}
                                onChange={handleChange}
                                />
                                <div className='edit-profile-desc'>Enter your current password to change the <i>E-mail address</i> or <i>Password.</i> <a href='/user/password'>Request new password.</a> </div>
                            </span></div>
                        )}
                           <div className="field-row">
                            <span className='label'><label>Status</label></span>
                           <span className='value'><div className="edit-profile-radio-group">
                                <div>
                                    <label>
                                        <input
                                            type="radio"
                                            name="status"
                                            value="0"
                                            checked={formData.status == '0'}
                                            onChange={handleChange}
                                        />
                                        <span className=''>Blocked</span>
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <input
                                            type="radio"
                                            name="status"
                                            value="1"
                                            checked={formData.status == '1'}
                                            onChange={handleChange}
                                        /> 
                                        <span className=''>Active</span>
                                    </label>
                                </div>
                            </div></span> 
                        </div>
                        
                        <div className='field-row'>
                           <span className='label'><label>Roles</label>  </span>                  
                            <span className='value'><div className='edit-profile-row-roles' style={{width: "60%"}}>
                                {rolesList.length > 0 && ( 
                                    <>
                                        {rolesList.map(({ id, name }) => (
                                    
                                            <label key={id}>
                                        
                                                <input
                                                    type="checkbox"
                                                    name="roles"
                                                    value={id}
                                                    // defaultChecked={formData.roles.includes(id) || false}
                                                    checked={formData.roles.includes(id) || false}
                                                    disabled={id == "2" ? "true" : ""}
                                                    onChange={handleRolesChange}
                                                />
                                                {name}
                                            </label>

                                        ))}
                                    </>
                                )}
                            </div></span>
                        </div>
                            <div className='field-row'>
                             <span className='label'><label>User Assignment </label></span>
                            <span className='value'>
                            <select
                                name="field_user_assignment"
                                value={formData.field_user_assignment}
                                onChange={handleChange}
                            >
                                <option value=""></option>
                                {salespersonList.length > 0 && (
                                <>
                                    {salespersonList.map((item, index) => {
                                        return <>
                                        {item['uid'] != null && (
                                            <><option value={item['uid']}>{item['name']}</option></>
                                        )}
                                    </>
                                    })}  
                                </>
                                )}
                                
                            </select></span>
                        </div>
                                                <fieldset className=''>
                            {/* <div className="edit-profile-row">
                                <label>Picture</label>
                                {formData.picture ? (  
                                    <><img  src={formData.picture} width="100px" height="100px" alt = "user"/></>
                                ):(
                                    <><img  src={domain_url+"pictures/notavailable.jpg"} width="100px" height="100px" alt = "user"/></>
                                )}
                                <br />
                                <input
                                    type="file"
                                    name="picture"
                                    onChange={handleFileChange}
                                />
                                <span className='edit-profile-desc'>
                                    Your virtual face or picture. Pictures larger than 1024x1024 pixels will be scaled down. 
                                    Image size must be a minimum of 100*100 px or a maximum of 1000*1000 px
                                </span>
                            </div> */}
                            <div className='field-row'>
                                <span className='label'> <label>Picture</label></span>
                                <span className='value'>
                                <a href={"/user/"+uid+"/view"} target="_blank" rel="noopener noreferrer" style={{ cursor: "pointer", display: "inline-block" }}>
                                    <img
                                        src={
                                            formData.picture instanceof File
                                            // ? URL.createObjectURL(formData.picture)
                                            ? previewImageUrl
                                            : formData.picture || domain_url + "pictures/notavailable.jpg"
                                        }
                                        width="100px"
                                        height="100px"
                                        alt="user"
                                    />
                                </a>
                                <br />
                                {/* {showDeletePictureCheckbox && (
                                    <>
                                    <input
                                        type="checkbox"
                                        id="edit-picture-delete"
                                        name="pictureDelete"
                                        checked={formData.pictureDelete}
                                        onChange={handleDeleteCheckboxChange}
                                    />
                                    <label htmlFor="edit-picture-delete" className="option" style={{fontWeight:"normal"}}>
                                        Delete picture
                                    </label>
                                    <div className="description">
                                        Check this box to delete your current picture.
                                    </div>
                                    </>
                                )} */}
                                <input
                                    type="file"
                                    name="picture"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    ref={fileInputRef}
                                    style={{marginTop: "5px"}}
                                />
                                <div className="edit-profile-desc">
                                    Your virtual face or picture. Pictures larger than 1024x1024 pixels will be scaled down. 
                                    Image size must be a minimum of 100*100 px or a maximum of 1000*1000 px
                                </div>
                                </span>
                            </div>
                        </fieldset>
                         <div className="field-row">
                            <span className='label'><label for="edit-field-ip-address">IP Address </label></span> 
                            <span className='value'> <input class="text-full form-text" type="text" id="edit-field-ip-address" name="field_ip_address" value={formData.field_ip_address}  maxlength="255"  onChange={handleChange}/></span>
                        </div>
                        <div className="field-row">
                            <span className='label'><label>Google Click ID </label></span>
                            <span class='value'>
                            <textarea
                                name="field_google_click_id"
                                value={formData.field_google_click_id}
                                onChange={handleChange}
                            />
                            <div className="grippie" 
                                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                            >   
                            </div></span>           
                        </div>
                                </>)}</fieldset>



                        {/* <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("timeZone")} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{toggles.timeZone ? '▼ ' : '▶ '}</span> 
                                <span className="toggle-titles">LOCALE SETTINGS</span>
                            </span>
                            {toggles.timeZone && (
                                <div className="fieldset-wrapper" style={{margin: "1em 0"}}>
                                    <label htmlFor='edit-timezone--2'>Time zone</label>
                                    <select
                                    name="timezone"
                                    value={formData.timezone || ""}
                                    onChange={handleTimezoneChange}
                                    className='admin-profile-timezone-select'
                                    >
                                    <option value="">- None selected -</option>
                                    {optionsWithTime.map((option) => (
                                        <option key={option.value} value={option.value}>
                                        {option.label}
                                        </option>
                                    ))}
                                    </select>
                                    <div className="description">
                                        Select the desired local time and time zone. Dates and times throughout this site will be displayed using this time zone.
                                    </div>
                                </div>
                            )}
                        </fieldset> */}                      



                      
                     {/* Revision information */}
                        {/* <div className="edit-profile-row">
                            <fieldset className='admin-edit-profile-toggle'>
                            <p style={{marginTop: "0px", fontWeight: "bold"}}>REVISION INFORMATION</p>
                            <label>Revision log message</label>
                            <textarea
                                name="revision"
                                value={formData.revision}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}>   
                            </div>
                            <div className='description'>    
                                Provide an explanation of the changes you are making. This will help other authors understand your motivations.
                            </div>
                            </fieldset>
                        </div> */} <fieldset className='admin-edit-profile-toggle'>
                                    {/* <div className="applied-courses field-row" style={{paddingLeft: "10px" ,border:0}}> */}
                                        {/* <div className="applied-courses-label" onClick={() => handleToggle("appliedCoursesList")}>
                                            <span style={{ fontSize: '10px',color:"#111" }}>{toggles.appliedCoursesList ? '▼ ' : '▶ '}</span>
                                           <span class="label"><label style={{display: "inline"}}>Applied Courses</label></span> 
                                        </div> */}
                                           <span onClick={() => handleToggle("appliedCoursesList")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Applied Courses</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.appliedCoursesList ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                                        {toggles.appliedCoursesList && (
                                            <div className="applied-courses-list">
                                                {courseList.length > 0 && ( 
                                                    <>
                                                        {courseList.map(({ id, course_code, course_name }) => (
                                                            <label key={id} className="checkbox-item">
                                                                <input
                                                                    type="checkbox"
                                                                    name="applied_courses"
                                                                    value={course_code}
                                                                    checked={formData.applied_courses.includes(course_code)}
                                                                    onChange={handleChange}
                                                                    className='applied-courses-list-input'
                                                                />
                                                                {course_name}
                                                            </label>
                                                        ))}
                                                    </>
                                                )}
                                            </div>
                                        )}
                                        
                                    {/* </div>  */}
                                    </fieldset>





                         <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("contact_address")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Contact & Address</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.contact_address ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.contact_address && (
                                <>
                        <div className="field-row">
                             <span class='label'><label>Street Address</label></span>
                           <span class='value'> <input
                                type="text"
                                name="field_street"
                                value={formData.field_street}
                                onChange={handleChange}
                            /></span>
                        </div>

                        <div className="field-row">
                            <span class='label'><label>Address (cont.)</label></span>
                            <span class='value'> <input
                                type="text"
                                name="field_street_2"
                                value={formData.field_street_2}
                                onChange={handleChange}
                            /></span>
                        </div>

                        <div className="field-row">
                            <span class='label'><label>City/Town</label></span>
                            <span class='value'> <input
                                type="text"
                                name="field_city"
                                value={formData.field_city}
                                onChange={handleChange}
                            /></span>
                        </div>

                        <div className="field-row">
                           <span class='label'><label>State/Province</label></span> 
                            <span class='value'> <select
                                name="field_state"
                                value={formData.field_state}
                                onChange={handleChange}
                            >
                                <option value="">Select State</option>
                                {Object.keys(statelist).map(state => {
                                        return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>;
                                        })}
                                {/* Add state options */}
                            </select></span> 
                        </div>

                        <div className="field-row">
                            <span class='label'><label>Zip/Postal Code</label></span>
                            <span class='value'> <input
                                type="text"
                                name="field_postal_code"
                                value={formData.field_postal_code}
                                onChange={handleChange}
                            /></span>
                        </div>
                        <div className="field-row">
                            <span class='label'><label>Country</label></span>
                          <span class='value'>   <select name="field_country" value={formData.field_country} onChange={handleChange}>
                                <option value="">Select Country</option>
                                {Object.keys(countrieslist).map(item => {
                                return <option key={countrieslist[item].label} value={countrieslist[item].label}>{countrieslist[item].label}</option>
                                })}
                            </select></span>
                        </div>

                        {(
                            userRoles.includes(configData.ROLE_AGENT) ||
                            userRoles.includes(configData.ROLE_SCOUT) ||
                            userRoles.includes(configData.ROLE_GLOBAL_AMBASSADOR)
                        ) && (
                            <div className="field-row">
                               <span class='label'> <label htmlFor="field_continentid">
                                    Continent 
                                    <span className="form-required" title="This field is required.">*</span>
                                </label></span>
                               <span class='value'>  <select
                                    id="field_continentid"
                                    name="field_continentid"                             
                                    value={formData.field_continentid}
                                    onChange={handleChange}                            
                                >
                                    <option value="">None</option>
                                    <option value="4">Asia</option>
                                    <option value="5">Africa</option>
                                    <option value="7">North America</option>
                                    <option value="2">South America</option>
                                    <option value="3">Europe</option>
                                    <option value="6">Australia/Oceania</option>
                                </select></span>
                            </div>
                        )}                                         
                    
                        <div className="field-row">
                           <span class='label'><label for="edit-field-nationality">Nationality </label></span> 
                           <span class='value'> <input className="text-full form-text" type="text" id="edit-field-nationality" name="field_nationality" value={formData.field_nationality}  maxlength="255" onChange={handleChange}/></span>
                        </div>
                          <div className="field-row">
                           <span class='label'> <label htmlFor="edit-field-night-phone">Night Phone </label></span>
                            <span class='value'><input 
                                className="" 
                                type="text" 
                                id="edit-field-night-phone" 
                                name="field_night_phone" 
                                value={formData.field_night_phone}
                                onChange={handleChange}
                                maxlength={100} 
                            /></span>
                        </div>

                        <div className="field-row">
                           <span class='label'> <label for="edit-field-fax">Fax </label></span>
                               <span class='value'><input 
                            className="form-text" 
                            type="text" 
                            id="edit-field-fax" 
                            name="field_fax" 
                            value={formData.field_fax} 
                            onChange={handleChange} 
                            maxlength="30"/></span> 
                        </div>

                        <div className="field-row">
                           <span class='label'> <label for="edit-field-pager">Pager </label></span>
                            <span class='value'><input 
                                className="form-text" 
                                type="text" 
                                id="edit-field-pager" 
                                name="field_pager" 
                                value={formData.field_pager} 
                                onChange={handleChange} 
                                maxlength="100"
                            /></span>
                        </div>
                            <div className="field-tellme-with-news&offers" id="edit-field-tellme-with-news&offers">
                            <div className="field-row">
                                <input
                                type="checkbox"
                                id="edit-field-tellme-with-news&offers"
                                name="field_text_me_with_news_offers"
                                checked={formData.field_text_me_with_news_offers === 1}
                                // defaultChecked={formData.field_text_me_with_news_offers === "1" ? "true":"false"}
                                onChange={handleChange}
                                className="form-checkbox"
                                />
                                <label className="option label" htmlFor="edit-field-tellme-with-news&offers">
                                Text me with news and offers 
                                </label>
                            </div>
                        </div>
                                </>)}</fieldset>
                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("applicationFields")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Key Applicant Info</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.applicationFields ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.applicationFields && (
                                <>
                                    <div className="field-row" style={{marginTop: "15px"}}>
                                        <span className="label"><label>appID</label></span>
                                         <span className="value">
                                        <input
                                            className='edit-profile-password-box'
                                            type="text"
                                            name="field_appid"
                                            value={formData.field_appid}
                                            onChange={handleChange}
                                        />
                                        </span>
                                    </div>
                            <div className="field-row">
                            <span className="label"><label>Primary Phone</label></span>
                             <span className="value">
                            <input
                                type="text"
                                name="field_phone"
                                value={formData.field_phone}
                                onChange={handleChange}
                            /></span>
                        </div>


                        <div className="field-row">
                            <span className="label"><label>Secondary Phone</label></span>
                             <span className="value">
                            <input
                                type="text"
                                name="field_secondary_phone"
                                value={formData.field_secondary_phone}
                                onChange={handleChange}
                            /></span>
                        </div> 

                                    <div className="field-row">
                                         <span className="label"><label>Province/Region</label></span>
                                       <span className="value"> <input
                                            type="text"
                                            name="field_province_region"
                                            value={formData.field_province_region}
                                            onChange={handleChange}
                                            maxLength={100}
                                        /></span>
                                    </div>

                                    <div className="field-row">
                                       <span className="label"><label>How did you hear about us?</label></span>
                                       <span className="value">
                                        <input
                                            type='text'
                                            name="field_sports_recom"
                                            value={formData.field_sports_recom}
                                            onChange={handleChange}
                                        /></span> 
                                    </div>

                                    <div className="field-row">
                                         <span className="label"><label>Referrer</label></span>
                                         <span className="value">
                                        <select
                                            name="field_referrer"
                                            value={formData.field_referrer}
                                            onChange={handleChange}
                                        >
                                            <option value="">- None -</option>
                                            <option value="Baseball America">Baseball America</option>
                                            <option value="DegreesinSports.com">DegreesinSports.com</option>
                                            <option value="Dr. Lashbrook gave me his business card!">Dr. Lashbrook gave me his business card!</option>
                                            <option value="ESPN">ESPN</option>
                                            <option value="Fox Sports Radio">Fox Sports Radio</option>
                                            <option value="Hockey News">Hockey News</option>
                                            <option value="My professor">My professor</option>
                                            <option value="NASSM">NASSM</option>
                                            <option value="NCAA News">NCAA News</option>
                                            <option value="Other">Other</option>
                                            <option value="Racingjunk.com">Racingjunk.com</option>
                                            <option value="Rah Rah Rugby">Rah Rah Rugby</option>
                                            <option value="Search Engine">Search Engine</option>
                                            <option value="Sherdog.com">Sherdog.com</option>
                                            <option value="SLAM magazine">SLAM magazine</option>
                                            <option value="SMWW Alumni told me about it">SMWW Alumni told me about it</option>
                                            <option value="SMWW Faculty">SMWW Faculty</option>
                                            <option value="WorkinSports.com">WorkinSports.com</option>
                                        </select>
                                        </span>
                                    </div>

                                    <div className="field-row">
                                       <span className="label"> <label>Name of person who referred you:</label></span>
                                       <span className="value">
                                        <input
                                            type="text"
                                            name="field_team_refer"
                                            value={formData.field_team_refer}
                                            onChange={handleChange}
                                        />
                                        </span>
                                    </div>

                                    <div className="edit-profile-row-multi-input field-row gender-radio">
                                       <span className="label gender-label">  <label>Gender</label></span>
                                       <span className="value">
                                        <div className="edit-profile-radio-group">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_gender"
                                                    value="N/A"
                                                    checked={formData.field_gender === 'N/A'}
                                                    onChange={handleChange}
                                                /> N/A
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_gender"
                                                    value="Male"
                                                    checked={formData.field_gender === 'Male'}
                                                    onChange={handleChange}
                                                /> Male
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_gender"
                                                    value="Female"
                                                    checked={formData.field_gender === 'Female'}
                                                    onChange={handleChange}
                                                /> Female
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_gender"
                                                    value="Non-binary"
                                                    checked={formData.field_gender === 'Non-binary'}
                                                    onChange={handleChange}
                                                /> Non-binary
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_gender"
                                                    value="Prefer not to answer"
                                                    checked={formData.field_gender === 'Prefer not to answer'}
                                                    onChange={handleChange}
                                                /> Prefer not to answer
                                            </label>
                                        </div></span>
                                    </div>

                                  


                                    <div className="field-row">
                                         <span className="label"> <label>Major / Degree / Course Completed</label></span>
                                          <span className="value">
                                        <input
                                            type="text"
                                            name="field_degree"
                                            value={formData.field_degree}
                                            onChange={handleChange}
                                        />                                        
                                        </span>
                                    </div>

                                    <div className="field-row">
                                         <span className="label"><label>Current Job</label></span>
                                        <span className="value"> <input
                                            type="text"
                                            name="field_current_job" 
                                            value={formData.field_current_job}
                                            onChange={handleChange}
                                        /></span>
                                    </div>
                      

                                    <div className="edit-profile-row-multi-input field-row">
                                        <span className="label"><label>Are You a Member of the Military?</label></span>
                                        <span className="value">
                                        <div className="edit-profile-radio-group">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="field_military"
                                                    value="N/A"
                                                    checked={formData.field_military === 'N/A'}
                                                    onChange={handleChange}
                                                /> N/A
                                                </label>
                                                <label>
                                                <input
                                                    type="radio"
                                                    name="field_military"
                                                    value="Yes"
                                                    checked={formData.field_military === 'Yes'}
                                                    onChange={handleChange}
                                                /> Yes
                                                </label>
                                                <label>
                                                <input
                                                    type="radio"
                                                    name="field_military"
                                                    value="No"
                                                    checked={formData.field_military === 'No'}
                                                    onChange={handleChange}
                                                /> No
                                                </label>
                                        </div>
                                        </span>
                                    </div>

                                    <div className="field-row" style={{width: "100%"}}>
                                       <span className="label"> <label>If Yes, please provide your military ID number</label></span>
                                        <span className="value">
                                        <input
                                            type="text"
                                            name="field_military_id"
                                            value={formData.field_military_id}
                                            onChange={handleChange}
                                        /></span>
                                    </div>
                        
                                    <div className="edit-profile-row-multi-input field-row">
                                        <span className="label"><label>Have you ever been convicted of a felony?</label></span>
                                        <span className="value">
                                        <div className="edit-profile-radio-group">
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_been_convicted"
                                                value="N/A"
                                                checked={formData.field_been_convicted === 'N/A'}
                                                onChange={handleChange}
                                            /> N/A
                                            </label>
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_been_convicted"
                                                value="Yes"
                                                checked={formData.field_been_convicted === 'Yes'}
                                                onChange={handleChange}
                                            /> Yes
                                            </label>
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_been_convicted"
                                                value="No"
                                                checked={formData.field_been_convicted === 'No'}
                                                onChange={handleChange}
                                            /> No
                                            </label>
                                        </div>
                                        </span>
                                    </div>

                                    <div className="field-row">
                                       <span className="label">   <label>If yes, please explain</label></span>
                                        <span className="value">
                                        <input
                                            type='text'
                                            name="field_felony"
                                            value={formData.field_felony}
                                            onChange={handleChange}
                                        /></span>
                                    </div>

                                    <div className="edit-profile-row-multi-input field-row">
                                       <span className="label">    <label>Do you plan to take this course toward college credit?</label></span>
                                        <span className="value">
                                        <div className="edit-profile-radio-group">
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_is_for_credit"
                                                value="N/A"
                                                checked={formData.field_is_for_credit === 'N/A'}
                                                onChange={handleChange}
                                            /> N/A
                                            </label>
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_is_for_credit"
                                                value="Yes"
                                                checked={formData.field_is_for_credit === 'Yes'}
                                                onChange={handleChange}
                                            /> Yes
                                            </label>
                                            <label>
                                            <input
                                                type="radio"
                                                name="field_is_for_credit"
                                                value="No"
                                                checked={formData.field_is_for_credit === 'No'}
                                                onChange={handleChange}
                                            /> No
                                            </label>
                                        </div>
                                        </span>
                                    </div>

                                    <div className="field-row" style={{width:"100%"}}>
                                       <span className="label"><label>If you could work for your favorite sports team, who would it be?</label></span>
                                        <span className="value"><input
                                            type="text"
                                            name="field_favteam"
                                            value={formData.field_favteam}
                                            onChange={handleChange}
                                        /></span>
                                    </div>

                                    <div className="field-row">
                                        <span class="label"><label>Tell Us Your Story:</label></span>
                                         <span className="value">
                                        <textarea
                                            name="field_elaborate"
                                            value={formData.field_elaborate}
                                            onChange={handleChange}
                                        />
                                        <div className="grippie" style={{
                                            background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                        }}></div>
                                        
                                        <div className="description">
                                            To help us understand you as an individual and not just an applicant, please tell us about why you are interested in taking this course.
                                        </div></span>
                                    </div>



                                    <div className="date-picker field-row">
                                       <span className="label"><p>DATE OF ACCEPTANCE</p>
                                      {/* <label htmlFor="date_of_acceptance">Date</label> */}
                                      </span>
                                            {/* <DatePicker
                                            selected={formData.field_date_of_acceptance}
                                            onChange={(date) => setFormData({ ...formData, field_date_of_acceptance: date })}
                                            dateFormat="yyyy-MM-dd"
                                        // placeholderText={currentFormattedDate}
                                            id="date_of_acceptance"
                                            name="field_date_of_acceptance"
                                        /> */}
                                        <span className="value">
                                        <DatePicker 
                                            ref={DateofAcceptRef}
                                            name="field_date_of_acceptance"
                                            // selected={formData.field_date_of_acceptance ? new Date(formData.field_date_of_acceptance) : null}
                                            selected={safeParseDate(formData.field_date_of_acceptance)}
                                            // onChange={handleDateChange}
                                            onChange={(date) => {
                                                handleDateChange(date, "field_date_of_acceptance");
                                                setTimeout(() => {
                                                    const input = DateofAcceptRef.current?.input;
                                                    if (input) {
                                                    const len = input.value.length;
                                                    input.setSelectionRange(len, len);
                                                    }
                                                }, 0);
                                            }}
                                        /><br/>
                                        <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span></span>
                                    </div>                                    
                                   <div className="edit-profile-common-checkbox field-row">
                                        <div className='value'>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="sales-call-made"
                                                name="field_sales_call_made"
                                                value = "1" 
                                                // defaultChecked={formData.field_sales_call_made == "1" ? "true" : ""}
                                                checked={formData.field_sales_call_made == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="sales-call-made">Sales Call Made</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="field_app_is_agent"
                                                name="field_app_is_agent"
                                                value = "1" 
                                                // defaultChecked={formData.field_app_is_agent == "1" ? "true" : ""}
                                                checked={formData.field_app_is_agent == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="field_app_is_agent">App is Agent</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="app_is_scout"
                                                name="field_app_is_scout"
                                                value = "1" 
                                                // defaultChecked={formData.field_app_is_scout == "1" ? "true" : ""}
                                                checked={formData.field_app_is_scout == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="app_is_scout">App is Scout</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="over18"
                                                name="field_over18"
                                                value = "1" 
                                                // defaultChecked={formData.field_over18 == "1" ? "true" : ""}
                                                checked={formData.field_over18 == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="over18">Over 18</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="dormant"
                                                name="field_dormant"
                                                value = "1" 
                                                // defaultChecked={formData.field_dormant == "1" ? "true" : ""}
                                                checked={formData.field_dormant == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="dormant">Dormant</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="srm400"
                                                name="field_srm400"
                                                value = "1" 
                                                // defaultChecked={formData.field_srm400 == "1" ? "true" : ""}
                                                checked={formData.field_srm400 == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="srm400">SRM400</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="am400"
                                                name="field_am400"
                                                value = "1" 
                                                // defaultChecked={formData.field_am400 == "1" ? "true" : ""}
                                                checked={formData.field_am400 == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="am400">AM 400</label>
                                        </div>
                                        <div className="form-type-checkbox">
                                            <input
                                                type="checkbox"
                                                id="gi_bill"
                                                name="field_gi_bill"
                                                value = "1" 
                                                // defaultChecked={formData.field_gi_bill == "1" ? "true" : ""}
                                                checked={formData.field_gi_bill == "1" ? "true" : ""}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            <label className="option label" htmlFor="gi_bill">GI Bill</label>
                                        </div>
                                        </div>
                                    </div>

                                    <div className="field-row">
                                        <span class="label"><label htmlFor="edit-field-gi-bill-status">GI Bill Status</label></span>
                                        <span class="value">
                                        <select
                                            id="edit-field-gi-bill-status"
                                            name="field_gi_bill_status"
                                            className="form-select"
                                            value={formData.field_gi_bill_status}
                                            onChange={handleChange}
                                        >
                                            <option value="_none">- None -</option>
                                            <option value="1">Eligible for GI Bill</option>
                                            <option value="2">Filled out Veteran's ID with WOU</option>
                                            <option value="3">Has Registration form</option>
                                            <option value="4">Faxed Completed Registration form to SMWW</option>
                                            <option value="5">GI Bill Completed</option>
                                        </select></span>
                                    </div>

                                    <div className="date-picker field-row">
                                        <span className="label"><p>BIRTHDAY</p></span>
                                         {/* <label>Date</label> */}
                                       <span className="value"> 
                                        <DatePicker 
                                            ref={birthDateRef}
                                            name="field_birthday"
                                            // selected={formData.field_birthday ? new Date(formData.field_birthday) : null}
                                            selected={safeParseDate(formData.field_birthday)}
                                            // onChange={handleDateChange}
                                            onChange={(date) => {
                                                handleDateChange(date, "field_birthday");
                                                setTimeout(() => {
                                                    const input = birthDateRef.current?.input;
                                                    if (input) {
                                                    const len = input.value.length;
                                                    input.setSelectionRange(len, len);
                                                    }
                                                }, 0);
                                            }}
                                        /><br/>
                                        <span className='edit-profile-desc'>E.g., {currentFormattedBDate}</span></span>
                                    </div>

                                    <div className="form-type-checkbox field-row">
                                        <div>
                                        <input
                                            type="checkbox"
                                            id="edit-field-new-apply"
                                            name="field_new_apply"
                                            value = "1" 
                                            // defaultChecked={formData.field_new_apply == "1" ? "true" : ""}
                                            checked={formData.field_new_apply == "1" ? "true" : ""}
                                            onChange={handleChange}
                                            className="form-checkbox"
                                        />
                                        <label className="option label" htmlFor="edit-field-new-apply">
                                            New Apply
                                        </label>
                                        <div className="description">
                                            Used when new application submit, even it's a exists account, use this field when divvy.
                                        </div></div>
                                    </div>

                                    <div className="field-row">
                                         <span className="label"> <label>How did you hear about the DOC Talk?</label></span>
                                          <span className="value"> 
                                        <select
                                            name="field_hear_about_doc_talk"
                                            value={formData.field_hear_about_doc_talk}
                                            onChange={handleChange}
                                        >
                                            <option value="">- None -</option>
                                            <option value="Facebook">Facebook</option>
                                            <option value="Family/Friend Referral">Family/Friend Referral</option>
                                            <option value="Instagram">Instagram</option>
                                            <option value="LinkedIn">LinkedIn</option>
                                            <option value="SMWW Mentor">SMWW Mentor</option>
                                            <option value="SMWW Newsletter">SMWW Newsletter</option>
                                            <option value="SMWW Website">SMWW Website</option>
                                            <option value="Twitter">Twitter</option>
                                        </select></span>
                                    </div>
                                    <div className="field-row">
                                       <span className="label"> <label htmlFor="field_doctalk_course_month">
                                            When are you looking to take a course?
                                        </label></span>
                                        <span className="label"><select                                            
                                            id="field_doctalk_course_month"
                                            name="field_doctalk_course_month"
                                            value={formData.field_doctalk_course_month}
                                            onChange={handleChange}
                                        >
                                            <option value="">-Select-</option>
                                            <option value="0-3 months">0–3 months</option>
                                            <option value="4-6 months">4–6 months</option>
                                            <option value="7-9 months">7–9 months</option>
                                        </select></span>
                                        </div>

                                </>
                            )}
                        </fieldset> 
                                                            <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("application_systemdata")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Application & System Data</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.application_systemdata ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.application_systemdata && (
                                <>
                            <div className="field-row">
                             <span className="label"><label htmlFor="reg_step">App Register Step</label></span>
                               <span className="value"><select
                                id="appRegister_step"
                                name="field_reg_step"
                                className="adduser-register-select"
                                value={formData.field_reg_step}
                                onChange={handleChange}
                                >
                                <option value="_none">- None -</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                            </select></span> 
                        </div>
                                <div className="field-row">
                                        <span className="label"><label htmlFor="edit-field-app-status">App Status</label></span>
                                       <span className="value"><select
                                            id="edit-field-app-status"
                                            name="field_app_status"
                                            className="form-select"
                                            value={formData.field_app_status}
                                            onChange={handleChange}
                                        >
                                            <option value="_none">- None -</option>
                                            <option value="1">Denied</option>
                                            <option value="2">Pending</option>
                                            <option value="3">Approved need payment</option>
                                            <option value="4">Approved and paid</option>
                                            <option value="5">Approved and fee waived</option>
                                            <option value="6">Approved and paid in partial</option>
                                            <option value="7">Didn't take class</option>
                                            <option value="8">Job app</option>
                                            <option value="9">More info request</option>
                                            <option value="10">Talk to Lynn</option>
                                            <option value="11">India Meet and Greet</option>
                                        </select></span> 
                                    </div> 
                                    <div className="date-picker field-row">
                                       <span className="label"> <p>DATE OF APP</p>
                                       {/* <label htmlFor="date_of_app">Date</label> */}
                                       </span> 
                                        {/* <DatePicker
                                            selected={formData.field_date_of_app}
                                            onChange={(date) => setFormData({ ...formData, field_date_of_app: date })}
                                            dateFormat="yyyy-MM-dd"
                                            // placeholderText={currentFormattedDate}
                                            id="date_of_app"
                                            name="field_date_of_app"
                                        /> */}
                                         <span className="value">
                                        <DatePicker 
                                            ref={DateofAppRef}
                                            name="field_date_of_app"
                                            // selected={formData.field_date_of_app ? new Date(formData.field_date_of_app) : null}
                                            selected={safeParseDate(formData.field_date_of_app)}
                                            // onChange={handleDateChange}
                                            onChange={(date) => {
                                                handleDateChange(date, "field_date_of_app");
                                                setTimeout(() => {
                                                    const input = DateofAppRef.current?.input;
                                                    if (input) {
                                                    const len = input.value.length;
                                                    input.setSelectionRange(len, len);
                                                    }
                                                }, 0);
                                            }}
                                        /><br/>
                                        <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span></span>
                                    </div>
                                    {/* Biography */} 
                        <div className="field-row">
                            <span class='label'><label>Biography</label></span>  
                            <span class='value'>         
                            {editorMode.biography ? (               
                                <Editor value={formData.field_biography} onChange={e => onEditorChange('field_biography', e.target.value)} /> 
                            ) : (
                                <>	
                                    <textarea className="edit-agent-form-bio" value={formData.field_biography} onChange={e => onEditorChange('field_biography', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}
                            <a onClick={() => toggleEditor('biography')}>Switch to {editorMode.biography ? 'Plain' : 'Rich'} Editor</a></span>
                        </div> 
                             <div className="field-row">
                            <span class='label'> <label>First Form Submitted </label></span>
                            <span class='value'>
                            <textarea
                                name="field_first_form_submission"
                                value={formData.field_first_form_submission}
                                onChange={handleChange}
                            />
                            <div className="grippie" 
                                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                            >   
                            </div></span>    
                        </div>
                        
                        <div className="field-row">
                           <span class='label'><label for="edit-field-most-recent-college">Last Form Submitted </label></span> 
                            <span className="value"><input className="text-full form-text" type="text" id="edit-field-last-form-submitted" name="field_last_form_submitted" value={formData.field_last_form_submitted} size="60" maxlength="600" onChange={handleChange}/></span>
                        </div>
                         <div className="field-row">
                            <span class='label'><label>Talk With Dr. Lashbrook </label></span>
                            <span class='value'>
                            <textarea
                                name="field_talk_with_dr_lashbrook"
                                value={formData.field_talk_with_dr_lashbrook}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div></span>              
                        </div>
                                   <div className="field-row">
                             <span class='label'><label>Degree Application </label></span>
                             <span class='value'>
                            <textarea
                                name="field_cuc_application"
                                value={formData.field_cuc_application}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div></span>                    
                        </div>

                       
                                </>)}</fieldset>

                                   <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("education")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Education</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.education ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.education && (
                                <>
                                  <div className="field-row">
                                      <span className="label">   <label>Education Level Completed</label></span>
                                      <span className="value">
                                        <input
                                            type="text"
                                            name="field_highest_grade"
                                            value={formData.field_highest_grade}
                                            onChange={handleChange}
                                        /></span>
                                    </div>
                                                  <div className="field-row">
                                        <span className="label"><label>Current Major</label></span>
                                        <span className="value">
                                        <input
                                            type="text"
                                            name="field_major"
                                            value={formData.field_major}
                                            onChange={handleChange}
                                        /></span>
                                    </div>
                                                           <div className="field-row">
                            <span className="label"><label htmlFor="edit-field-school">School </label></span>
                             <span className="value">
                            <input 
                                className="" 
                                type="text" 
                                id="edit-field-school" 
                                name="field_school" 
                                value={formData.field_school}
                                onChange={handleChange}
                                maxlength={50}
                            /></span>
                        </div>
                         <div className="field-row">
                                        <span className="label">  
                                        <label>University</label></span>
                                         <span className="value">
                                        <input
                                            type="text"
                                            name="field_college"
                                            value={formData.field_college}
                                            onChange={handleChange}
                                        />
                                        </span>
                                    </div>
                                     <div className="field-row">
                            <span className="label"> <label for="edit-field-most-recent-college">Most recent college </label></span>
                            <span className="value"><input class="text-full form-text" type="text" id="edit-field-most-recent-college" name="field_most_recent_college" value={formData.field_most_recent_college} size="60" maxlength="255" onChange={handleChange}/></span> 
                        </div>
                            <div className="field-row">
                           <span className="label"> <label htmlFor="edit-field-last-attended">Last Attended Education </label></span>
                           <span className="value"><select 
                                id="edit-field-last-attended" 
                                name="field_last_attended" 
                                value={formData.field_last_attended}
                                onChange={handleChange}
                                className=""
                            >
                            <option value="_none">- None -</option>
                            {schoolYears.map((y) => (
                                <option key={y.value} value={y.value}>
                                {y.label}
                                </option>
                            ))}
                            </select></span> 
                        </div>
                         <div className="field-row date-picker">
                            <span class='label'><p>RECENT GRADUATION DATE </p>
                            {/* <label htmlFor="recent-graduation-date">Date</label> */}
                            </span>
                            {/* <DatePicker
                                selected={formData.field_recent_graduation_date}
                                onChange={(date) => setFormData({ ...formData, field_recent_graduation_date: date })}
                                dateFormat="yyyy-MM-dd"
                                // placeholderText={currentFormattedDate}
                                id="recent-graduation-date"
                                name="field_recent_graduation_date"
                            /> */}
                            <span class='value'>
                            <DatePicker 
                                ref={recentGradDateRef}
                                name="field_recent_graduation_date"
                                // selected={formData.field_recent_graduation_date ? new Date(formData.field_recent_graduation_date) : null}
                                selected={safeParseDate(formData.field_recent_graduation_date)}
                                // onChange={handleDateChange}
                                onChange={(date) => {
                                    handleDateChange(date, "field_recent_graduation_date");
                                    setTimeout(() => {
                                        const input = recentGradDateRef.current?.input;
                                        if (input) {
                                        const len = input.value.length;
                                        input.setSelectionRange(len, len);
                                        }
                                    }, 0);
                                }}
                            /><br/>
                            <span className='edit-profile-desc'>Eg., {currentFormattedDate}</span></span>
                        </div>
                        <div className="field-row">
                            <span class='label'><label>Graduated Courses </label></span>
                             <span class='value'>
                            <textarea
                                name="field_graduated_courses"
                                value={formData.field_graduated_courses}
                                onChange={handleChange}
                            />
                            <div className="grippie" 
                                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                            >   
                            </div></span>       
                        </div> 
                            <div className="field-row">
                                       <span className="label"> <label>High School</label></span>
                                       <span className="value">
                                        <input
                                            type="text"
                                            name="field_high_school"
                                            value={formData.field_high_school}
                                            onChange={handleChange}
                                            
                                        /></span>
                                    </div>

                                    <div className="field-row">
                                        <span className="label"><label>High School Location</label></span>
                                         <span className="value">
                                        <input
                                            type="text"
                                            name="field_hs_location"
                                            value={formData.field_hs_location}
                                            onChange={handleChange}
                                        /></span>
                                    </div>

                                    <div className="field-row">
                                         <span className="label"> <label>High School Graduation Year</label></span>
                                     <span className="value"><input
                                            type="text"
                                            name="field_hs_grad_year"
                                            value={formData.field_hs_grad_year}
                                            onChange={handleChange}
                                            maxLength={4}
                                        /></span>    
                                    </div>

                                    <div className="field-row">
                                       <span className="label">  <label>College Graduation Date</label></span>
                                      <span className="value">  <input
                                            type="text"
                                            name="field_college_grad_date"
                                            value={formData.field_college_grad_date}
                                            onChange={handleChange}
                                            maxLength={50}
                                        /></span>
                                    </div>
                         <div className="field-row">
                             <span className="label"><label htmlFor="edit-field-cuc-degrees-und">Applied Degrees</label></span>
                             <span class='value'>
                            <div id="edit-field-cuc-degrees" className="form-checkboxes">
                                {/* {degreesList.map(({ value, label }) => (
                                    <div
                                    key={value} 
                                    // className={`form-item form-type-checkbox form-item-field-cuc-degrees-${value}`}          
                                    >
                                        <label
                                        // className="option"
                                        style={{fontWeight:"normal"}}
                                        htmlFor={`edit-field-cuc-degrees-${value.toLowerCase()}`}
                                    >
                                        <input
                                    type="checkbox"
                                    id={`edit-field-cuc-degrees-${value.toLowerCase()}`}
                                    name="field_cuc_degrees"
                                    value={value}
                                    checked={(formData.field_cuc_degrees || []).includes(value)}
                                    onChange={handleChange}
                                    className="form-checkbox"
                                    />
                                
                                        {label}
                                    </label>
                                    </div>
                                ))} */}
                                {Object.entries(degreesList).map(([value, label]) => (
                          
                                    <div key={value}>
                                        <label
                                            style={{fontWeight:"normal"}}
                                            htmlFor={`edit-field-cuc-degrees-${value.toLowerCase()}`}
                                        >
                                            <input
                                                type="checkbox"
                                                id={`edit-field-cuc-degrees-${value.toLowerCase()}`}
                                                name="field_cuc_degrees"
                                                value={value}
                                                checked={(formData.field_cuc_degrees || []).includes(value)}
                                                onChange={handleChange}
                                                className="form-checkbox"
                                            />
                                            {label}
                                        </label>
                                    </div>
                                ))}
                            </div></span>
                        </div> 
                                               
                        <div className="field-row">
                            <span className="label"><label>Advanced Certificates Question </label></span>
                             <span class='value'>
                            <textarea
                                name="field_advanced_certificates_ques"
                                value={formData.field_advanced_certificates_ques}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div> </span>               
                        </div>



                       
                        <div className="field-row">
                            <span className="label"><label>Most recent seasons stats </label></span>	
                                <span class='value'>
                            {editorMode.most_recent_seasons_stats ? (
                                <Editor value={formData.field_most_recent_seasons_stats} onChange={e => onEditorChange('field_most_recent_seasons_stats', e.target.value)} />  
                            ) : (
                                <><textarea className="edit-agent-form-bio" value={formData.field_most_recent_seasons_stats} onChange={e => onEditorChange('field_most_recent_seasons_stats', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}  
                            <a onClick={() => toggleEditor('most_recent_seasons_stats')}>Switch to {editorMode.most_recent_seasons_stats ? 'Plain' : 'Rich'} Editor</a></span>          
                        </div>
                                </>)}</fieldset>
                         <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("social_links")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Social & Links</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.social_links ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.social_links && (
                                <>
                                   <div className="field-row">
                             <span class='label'><label>LinkedIn URL</label></span>
                             <span class='value'>
                            <textarea
                                name="field_linkedin_url"
                                value={formData.field_linkedin_url}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div></span>
                        </div>
                        <div className="field-row">
                            <span class='label'><label>Instagram URL</label></span>
                           <span class='value'> <input
                                type="text"
                                name="field_instagram_url"
                                value={formData.field_instagram_url}
                                onChange={handleChange}      
                            /></span>
                        </div>

                        {/* TikTok */}
                        <div className="field-row">
                            <span class='label'><label>TikTok URL</label></span> 
                            <span class='value'> <input
                                type="text"
                                name="field_tiktok_url"
                                value={formData.field_tiktok_url}
                                onChange={handleChange}
                            /></span> 
                        </div>

                        {/* Twitter */}
                        <div className="field-row">
                            <span class='label'> <label>Twitter URL</label></span>
                           <span class='value'>  <input
                                type="text"
                                name="field_twitter_url"
                                value={formData.field_twitter_url}
                                onChange={handleChange}
                            /></span>
                        </div>

                        {/* YouTube */}
                        <div className="field-row">
                            <span class='label'> <label>YouTube URL</label></span>
                          <span class='value'>   <input
                                type="text"
                                name="field_user_youtube_url"
                                value={formData.field_user_youtube_url}
                                onChange={handleChange}
                            /></span>
                        </div>
                        
                        {/* Facebook */}
                        <div className="field-row">
                            <span class='label'> <label>Facebook URL</label></span>
                            <span class='value'> <input
                                type="text"
                                name="field_facebook_url"
                                value={formData.field_facebook_url}
                                onChange={handleChange}     
                            /></span>
                        </div>

                        <div className="field-row">
                            <span class='label'><label>Instagram Handle</label></span> 
                            <span class='value'> <input
                                type="text"
                                name="field_instagram_handle"
                                value={formData.field_instagram_handle}
                                onChange={handleChange}      
                            /></span> 
                        </div>

                        {/* LinkedIn */}
                        <div className="field-row">
                            <span class='label'> <label>LinkedIn Handle</label></span>
                            <span class='value'> <input
                                type="text"
                                name="field_linkedin_handle"
                                value={formData.field_linkedin_handle}
                                onChange={handleChange}
                            /></span>
                        </div>

                        <div className="field-row">
                             <span class='label'><label>Facebook Handle</label></span>
                            <span class='value'> <input
                                type="text"
                                name="field_facebook_handle"
                                value={formData.field_facebook_handle}
                                onChange={handleChange}
                            /></span>
                        </div>
                        <div className="field-row">
                            <span class='label'> <label>Instagram Followers</label></span>
                           <span class='value'>  <input
                                type="text"
                                name="field_instagram_followers"
                                value={formData.field_instagram_followers}
                                onChange={handleChange}     
                            /></span>
                        </div>        
                
                        <div className="field-row">
                            <span class='label'> <label>Facebook Followers</label></span>
                           <span class='value'>  <input
                                type="text"
                                name="field_facebook_followers"
                                value={formData.field_facebook_followers}
                                onChange={handleChange}
                            /></span>
                        </div>
                    
                        <div className="field-row">
                            <span class='label'><label>Twitter Followers</label></span> 
                            <span class='value'> <input
                                type="text"
                                name="field_twitter_followers"
                                value={formData.field_twitter_followers}
                                onChange={handleChange}
                            /></span> 
                        </div>
                
                        <div className="field-row">
                            <span class='label'> <label>YouTube Subscribers</label></span>
                            <span class='value'> <input
                                type="text"
                                name="field_youtube_subscribers"
                                value={formData.field_youtube_subscribers}
                                onChange={handleChange}
                            /></span>
                        </div>

                        <div className="field-row">
                            <span class='label'> <label>LinkedIn Followers</label></span>
                           <span class='value'>  <input
                                type="text"
                                name="field_linkedin_followers"
                                value={formData.field_linkedin_followers}
                                onChange={handleChange}
                            /></span>
                        </div>
                
                        <div className="field-row">
                            <span class='label'> <label>TikTok Followers</label></span>
                            <span class='value'> <input
                                type="text"
                                name="field_tiktok_followers"
                                value={formData.field_tiktok_followers}
                                onChange={handleChange}
                            /></span>
                        </div>
                                </>)}</fieldset>
                         <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("background_career")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Background & career</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.background_career ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.background_career && (
                                <>
                            <div className="field-row">
                            <span class='label'><label>What team/organization are you with?</label></span>
                            <span class='value'>
                            <input
                                type="text"
                                name="field_team_organization"
                                value={formData.field_team_organization}
                                onChange={handleChange}
                            /></span>
                            </div>
                        <div className="field-row" style={{width: "100%"}}>
                            <span class='label'><label>Which sport(s) do you want to work in the most? </label></span>
                            <span class='value'><select multiple size={8} style={{width:"300px"}} value={formData.field_sports_you_worked} onChange={handleSportsyouWorkedChange}>
                                {/* {SportsyouWorked.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))} */}
                                {Object.entries(SportsyouWorked).map(([value, label]) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </select></span>
                        </div>

                        <div className='field-row'>
                            <span class='label'><label htmlFor="edit-field-other-sports-you-worked">Other Sports you worked </label></span>
                            <span class='value'><input className="text-full form-text" type="text" id="edit-field-other-sports-you-worked" name="field_other_sports_you_worked" value={formData.field_other_sports_you_worked} maxlength="255" onChange={handleChange}/></span>
                        </div>

                        <div className="field-row" style={{width: "100%"}}>
                            <span class='label'><label>Which job role would best describe your dream job?</label></span>
                             <span class='value'><select multiple size={8} style={{width:"300px"}} value={formData.field_your_dream_job} onChange={handleDreamJobChange}>
                                {Object.entries(dreamJob).map(([value, label]) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </select></span>
                        </div>

                        <div className='field-row'>
                            <span class='label'><label htmlFor="edit-field-other-dream-job">Other dream job</label></span>
                            <span class='value'><input className="text-full form-text" type="text" id="edit-field-other-dream-job" name="field_other_dream_job" value={formData.field_other_dream_job} maxlength="255" onChange={handleChange}/></span>
                        </div>
                                 {/* Sports Focus */}
                        <div className="field-row">
                            <span class='label'><label>Sports Focus</label></span>
                            <span class='value'><select multiple size={8} style={{width:"300px"}} value={formData.field_sports_focus} onChange={handleSportsFocusChange}>
                                {Object.entries(sportsfocus).map(([value, label]) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </select></span>
                        </div>
                        {/* Career information */}          
                        <div className="field-row">
                           <span class='label'> <label>Career information</label> </span>
                                <span class='value'>
                            {editorMode.careerinfo ? (			  
                                <Editor value={formData.field_career_information} onChange={e => onEditorChange('field_career_information', e.target.value)} />  
                            ) : (
                                <>	
                                    <textarea className="edit-agent-form-bio" value={formData.field_career_information} onChange={e => onEditorChange('field_career_information', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}        
                            <a onClick={() => toggleEditor('careerinfo')}>Switch to {editorMode.careerinfo ? 'Plain' : 'Rich'} Editor</a></span>          
                        </div>

                        {/* Sports Background */}
                        <div className="field-row">
                            <span class='label'> <label>Sports Background</label></span>
                            <span class='value'>
                            <textarea
                                name="field_sports_background"
                                value={formData.field_sports_background}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div></span>
                        </div>
                                                {/* Professional Background */}
                        <div className="field-row">
                            <span class='label'><label htmlFor="edit-field-professional-background">Professional Background</label></span>
                            <span class='value'>
                            <textarea
                                name="field_professional_background"
                                value={formData.field_professional_background}
                                onChange={handleChange}
                                id="edit-field-professional-background"
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div></span>
                        </div>

                        {/* Volunteer Work */}
                        <div className="field-row">
                            <span class='label'><label htmlFor="edit-field-volunteer-work">Volunteer Work</label></span>
                            <span class='value'>
                            <textarea
                                name="field_volunteer_work"
                                value={formData.field_volunteer_work}
                                onChange={handleChange}
                                id="edit-field-volunteer-work"
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div></span>
                        </div>
                          {/* Mission Statement */}
                        <div className="field-row">
                           <span class='label'>  <label htmlFor="edit-field-mission-statement">Mission Statement</label></span>
                           <span class='value'>
                            <textarea
                                name="field_mission_statement"
                                value={formData.field_mission_statement}
                                onChange={handleChange}
                                id="edit-field-mission-statement"
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div></span>
                        </div>
                    <div className="field-row">
                           <span class='label'><label>Job Resume </label></span>
                            <span class='value'>
                            <textarea
                                name="field_job_resume"
                                value={formData.field_job_resume}
                                onChange={handleChange}
                            />
                            <div className="grippie" 
                                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                            >   
                            </div></span>       
                        </div>                                     

                                </>)}</fieldset>




                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("miscellaneous")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Miscellaneous</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.miscellaneous ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.miscellaneous && (
                                <>
                        <div className="field-row">
                           <span class='label'> <label htmlFor="meta_title">Meta Title</label></span>
                            <span class='value'><input className='' type="text" id="meta_title" name="field_meta_title" value={formData.field_meta_title} onChange={handleChange}  /> </span>
                        </div>

                     

                        <div className="field-row">
                             <span class='label'><label htmlFor="meta_keywords">Meta Keywords</label></span>
                            <span class='value'><input className='' type="text" id="meta_keywords" name="field_meta_keywords" value={formData.field_meta_keywords} onChange={handleChange}  /> </span>
                        </div>

                        <div className="field-row">
                            <span class='label'><label>Meta Description</label></span>
                            <span class='value'>
                            <textarea
                                name="field_meta_description"
                                value={formData.field_meta_description}
                                onChange={handleChange}
                            />
                            <div className="grippie" 
                                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                            >   
                            </div>
                            <div className='description'>    
                                If left blank, the first 160 characters of the biography will pull.
                            </div></span>
                        </div>
                        
                        <div className="field-row">
                            <input
                                type="checkbox"
                                id="edit-field-add-to-divvy-draft"
                                name="field_add_to_divvy_draft"
                                value = "1" 
                                // defaultChecked={formData.field_add_to_divvy_draft == "1" ? "true" : ""}
                                checked={formData.field_add_to_divvy_draft == "1" ? "true" : ""}
                                onChange={handleChange}
                                className="form-checkbox"
                            />
                            <label className="option label" htmlFor="edit-field-add-to-divvy-draft">Include in Divvy Draft </label>
                        </div>
                        <div className="field-row">
                           <span class='label'><label htmlFor="edit-field-other-referrer">Referrer Other </label></span> 
                            <span class='value'><input 
                                className="" 
                                type="text" 
                                id="edit-field-other-referrer" 
                                name="field_other_referrer" 
                                value={formData.field_other_referrer}
                                onChange={handleChange}
                                maxlength={120} 
                            /></span>
                        </div>
                               
                    

                        <div className="field-row">
                           <span class='label'><label htmlFor="edit-field-education-state">State </label></span> 
                           <span class='value'> <input 
                                className="" 
                                type="text" 
                                id="edit-field-education-state" 
                                name="field_education_state" 
                                value={formData.field_education_state}
                                onChange={handleChange} 
                                maxlength={50} 
                            /></span>
                        </div>

                        <div className="field-row">
                            <span class='label'><label htmlFor="edit-field-education-city">City </label></span>
                           <span class='value'> <input 
                                className="" 
                                type="text" 
                                id="edit-field-education-city" 
                                name="field_education_city" 
                                value={formData.field_education_city}
                                onChange={handleChange}
                                maxlength={50} 
                            /></span>
                        </div>
                        <div className="field-row">
                            <span class='label'><label htmlFor="agency_scout_email">Agency-scout Email</label></span>
                            <span class='value'><input 
                                className="" 
                                type="text" 
                                id="agency_scout_email" 
                                name="field_smww_email" 
                                value={formData.field_smww_email} 
                                onChange={handleChange}  
                            /> </span>
                        </div>
                        <div className="field-row">
                            <span class='label'><label>Agents Represented By </label></span>
                            <span class='value'><select multiple size={8} style={{width:"300px"}}value={formData.field_agents_represented_by} onChange={handleAgentRepresentChange}>
                                {/* {AgentReprsentedBy.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))} */}
                                {agentlist.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select></span>
                        </div>
                       <div className="field-row">
                             <span class='label'><label>Request More Info </label></span>
                             <span class='value'>
                            <textarea
                                name="field_request_more_info"
                                value={formData.field_request_more_info}
                                onChange={handleChange}
                            />
                            <div className="grippie" style={{
                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                            }}></div>  </span>          
                        </div>
                       {/* Education */} 
                        <div className="field-row">
                           <span class='label'><label>Education</label>  </span>
                                    <span class='value'> 
                            {editorMode.education ? (
                                <Editor value={formData.field_education} onChange={e => onEditorChange('field_education', e.target.value)} />
                            ) : (
                                <>	<textarea className="edit-agent-form-bio" value={formData.field_education} onChange={e => onEditorChange('field_education', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )} 
                            <a onClick={() => toggleEditor('education')}>Switch to {editorMode.education ? 'Plain' : 'Rich'} Editor</a></span>
                        </div>
                        {/* Q&A */}         
                        <div className="field-row">
                           <span class='label'> <label>Q&A</label></span>	
                                    <span class='value'>
                            {editorMode.qa ? (
                                <Editor value={formData.field_q_a} onChange={e => onEditorChange('field_q_a', e.target.value)} />  
                            ) : (
                                <><textarea className="edit-agent-form-bio" value={formData.field_q_a} onChange={e => onEditorChange('field_q_a', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}       
                            <a onClick={() => toggleEditor('qa')}>Switch to {editorMode.qa ? 'Plain' : 'Rich'} Editor</a></span>       
                        </div>
                        {/* How to Contact */}          
                        <div className="field-row">
                            <span class='label'><label>How to Contact</label></span>
                                    <span class='value'>
                            {editorMode.contact ? (
                                <Editor value={formData.field_how_to_contact_client} onChange={e => onEditorChange('field_how_to_contact_client', e.target.value)} /> 
                            ) : (
                                <>	<textarea className="edit-agent-form-bio" value={formData.field_how_to_contact_client} onChange={e => onEditorChange('field_how_to_contact_client', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}   
                            <a onClick={() => toggleEditor('contact')}>Switch to {editorMode.contact ? 'Plain' : 'Rich'} Editor</a></span>
                        </div>
                        <div className="field-row">
                            <span class='label'><label>Video Highlights </label></span>	
                                    <span class='value'>
                            {editorMode.video_highlights ? (
                                <Editor value={formData.field_video_highlights} onChange={e => onEditorChange('field_video_highlights', e.target.value)} />   
                            ) : (
                                <><textarea className="edit-agent-form-bio" value={formData.field_video_highlights} onChange={e => onEditorChange('field_video_highlights', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}    
                            <a onClick={() => toggleEditor('video_highlights')}>Switch to {editorMode.video_highlights ? 'Plain' : 'Rich'} Editor</a>  </span>        
                        </div>
                        {/* Athlete Contract */}
                        {/* <div className="field-row">
                            <span class='label'>Athlete Contract</span>
                        <div>
                            <span class='value'>
                            <fieldset>
                            <legend>
                              
                            </legend>
                            <div>
                                {(athleteUploadedFiles?.length > 0 || athletecontractuploadFiles?.length > 0) && (
                                <table style={{fontSize:"14px", width:"100%"}}>
                                    <thead>
                                    <tr style={{textAlign:"left"}}>
                                        <th>File information</th>
                                        <th>Operations</th>
                                    </tr>
                                    </thead>
                                    <tbody style={{backgroundColor: "#eee"}}>
                                    
                                    {athleteUploadedFiles.length > 0 &&  athleteUploadedFiles.map((file, index) => (
                                        <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                        <td>
                                            <span>
                                            <img
                                                alt="File icon"
                                                src={getFileIcon(file.name)}
                                                style={{ marginRight: '8px' }}
                                            />
                                            <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                                                {file.name}
                                            </a>
                                            </span>
                                            <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                                        </td>
                                        <td>
                                            <button
                                            type="button"
                                            className="form-submit"
                                            onClick={() => removeFile(index, setAthleteUploadedFiles)}
                                            >
                                            Remove
                                            </button>
                                        </td>
                                        </tr>
                                    ))}
                                    {athletecontractuploadFiles && athletecontractuploadFiles.length > 0 && athletecontractuploadFiles.map((file, index) => (
                                        <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                        <td>
                                            <span>
                                            <img
                                                alt="File icon"
                                                src={getFileIcon(file.name)}
                                                style={{ marginRight: '8px' }}
                                            />
                                            <a href={file.url} target="_blank" rel="noreferrer">
                                                {file.name}
                                            </a>
                                            </span>
                                            <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                                        </td>
                                        <td>
                                            <button
                                            type="button"
                                            className="form-submit"
                                            onClick={() => removeAthleteContractFile(index,file.fid)}
                                            
                                            >
                                            Remove
                                            </button>
                                        </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                )}

                                
                                {athleteErrorMessage && (
                                <div 
                                    className="set-message-error" 
                                    style={{ 
                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, 
                                    padding: "10px 10px 10px 50px",
                                    width: "90%",
                                    }}
                                >
                                    {athleteErrorMessage}
                                </div>
                                )}
                                <div className="form-item">
                                <label htmlFor="edit-field-athlete-contract">Add a new file</label>
                                <div>
                                    <input
                                    type="file"
                                    id="edit-field-athlete-contract"
                                    name="field_athlete_contract"
                                    multiple
                                    onChange={(e) => handleFileInputChange(e, setAthleteSelectedFiles, setAthleteErrorMessage, setAthleteFileInputKey)}
                                    key={athleteFileInputKey}
                                    style={{width: "auto"}}
                                    />
                                    <button type="button" onClick={() => handleUpload(athleteSelectedFiles, setAthleteUploadedFiles, setAthleteErrorMessage, setAthleteSelectedFiles, setAthleteFileInputKey)} disabled={athleteSelectedFiles.length === 0} className="form-submit">
                                    Upload
                                    </button>
                                </div>
                                <div className="description">
                                    Files must be less than <strong>128 MB</strong>.<br />
                                    Allowed file types: <strong>txt, png, jpg, jpeg, pdf, docx</strong>.
                                </div>
                                </div>
                                        </div>
                                    </fieldset></span>
                                    </div>
                                </div> */}
                        {/* <div className="field-show-on-frontend-ambassador" id="edit-field-show-on-frontend-ambassado">
                            <div className="">
                                <input
                                    type="checkbox"
                                    id="edit-field-show-on-frontend-ambassado-und"
                                    name="field_show_on_frontend_ambassado"
                                    // defaultChecked={formData.field_show_on_frontend_ambassado === "1" ? "true":"false"}
                                    onChange={handleChange}
                                    className="form-checkbox"
                                />
                                <label className="option" htmlFor="edit-field-show-on-frontend-ambassado-und" style={{fontWeight: "normal"}}>
                                    Show on Frontend Global Ambassador
                                </label>
                            </div>
                        </div>
                        <div className='field-row'>
                            <span class='label'><label htmlFor="edit-field-ambassador-slug">Ambassador Slug</label></span>
                            <span class='value'><input className="" type="text" id="edit-field-ambassador-slug" name="field_ambassador_slug" value={formData.field_ambassador_slug} maxlength="255" onChange={handleChange}/></span>
                        </div> */}
                        
                        <div className="field-row">
                             <span class='label'><label htmlFor="edit-field-age">Age </label></span>
                             <span class='value'><input 
                                type="text" 
                                id="edit-field-age" 
                                name="field_age" 
                                value={formData.field_age}
                                onChange={handleChange} 
                                size={12} 
                                maxlength={10} 
                            /></span>
                        </div>
                                     <div className="field-row">
                                         <span class='label'><label htmlFor="edit-field-first-name-badge">Please enter your first name as you would like it to be displayed on your conference name badge </label></span>
                                        <span class='value'><input
                                            type="text" 
                                            id="edit-field-first-name-badge" 
                                            name="field_first_name_badge" 
                                            value={formData.field_first_name_badge}
                                            onChange={handleChange}
                                            maxlength={50} 
                                        /></span>
                                    </div>

                                    <div className="field-row">
                                         <span class='label'><label htmlFor="edit-field-last-name-badge">Please enter your last name as you would like it to be displayed on your conference name badge </label></span>
                                        <span class='value'><input
                                            type="text" 
                                            id="edit-field-last-name-badge" 
                                            name="field_last_name_badge" 
                                            value={formData.field_last_name_badge}
                                            onChange={handleChange}
                                            maxlength={50} 
                                        /></span>
                                    </div>

                                    <div className="field-row">
                                        <span class='label'><label htmlFor="edit-field-name-school-badge">Please enter your school or university as you would like it to be displayed on your conference name badge </label></span>
                                        <span class='value'><input
                                            type="text" 
                                            id="edit-field-name-school-badge" 
                                            name="field_name_school_badge" 
                                            value={formData.field_name_school_badge}
                                            onChange={handleChange}
                                            maxlength={100} 
                                        /></span>
                                        </div>

                                    <div className="field-row">
                                        <span class='label'><label htmlFor="edit-field-name-title-badge">Please enter your title as you would like it to be displayed on your conference name badge </label></span>
                                        <span class='value'><input
                                            type="text" 
                                            id="edit-field-name-title-badge" 
                                            name="field_name_title_badge" 
                                            value={formData.field_name_title_badge}
                                            onChange={handleChange}
                                            maxlength={100} 
                                        /></span>
                                    </div>

                                    <div className="field-row">
                                        <span class='label'><label htmlFor="edit-field-name-org-badge">Please enter your team or league as you would like it to be displayed on your conference name badge </label></span>
                                        <span class='value'> <input
                                            type="text" 
                                            id="edit-field-name-org-badge" 
                                            name="field_name_org_badge" 
                                            value={formData.field_name_org_badge}
                                            onChange={handleChange}
                                            maxlength={100} 
                                        /></span>
                                    </div>

                                    <div style={{marginBottom: "1em"}} className="field-row">
                                        <span class='label'><label for="edit-field-amount-paid">Amount Paid </label></span>
                                        <span class='value'><input type="text" id="edit-field-amount-paid" name="field_amount_paid" value={formData.field_amount_paid} size="14" maxlength="12" className="form-text" onChange={handleChange}/></span>
                                    </div>

                                    <div className="field-row">
                                        <span class='label'> <label for="edit-field-contact-id">Contact ID </label></span>
                                         <span class='value'><input className="text-full form-text" type="text" id="edit-field-contact-id" name="field_contact_id" value={formData.field_contact_id} size="60" maxlength="10" onChange={handleChange}/>
                                        <div className="description">Event attendee contact id in old system.</div></span>
                                    </div>

                                    <div className="field-row">
                                       <span class='label'> <label for="edit-field-event-id">Event ID </label></span>
                                         <span class='value'><input className="text-full form-text" type="text" id="edit-field-event-id" name="field_event_id" value={formData.field_event_id} size="60" maxlength="10" onChange={handleChange}/>
                                        <div className="description">Event attendee - event id in old system.</div></span>
                                    </div
>

                                    <div className="field-row">
                                       <span class='label'> <label for="edit-field-coupon-code">Coupon Code </label></span>
                                        <span class='value'><input className="text-full form-text" type="text" id="edit-field-coupon-code" name="field_coupon_code" value={formData.field_coupon_code} size="60" maxlength="30" onChange={handleChange}/>
                                        <div className="description">Event attendee - coupon code in old system.</div></span>
                                    </div>

                                    <div className="field-row">
                                       <span class='label'> <label>Contact Notes</label></span>
                                       <span class='value'>
                                        <textarea
                                            name="field_contact_notes"
                                            value={formData.field_contact_notes}
                                            onChange={handleChange}
                                        />
                                        <div className="grippie" 
                                            style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                        >   
                            
                                    </div><br/>
                                        <div className='description'>    
                                            Event attendee - notes
                                        </div></span>
                                    </div>
                                     <div className="field-row">
                                       <span class='label'><label htmlFor="edit-field-lead-type">Lead Type</label></span>  
                                        {/* {leadList.length > 0 && (
                                            <>
                                                {leadList.map((leadType) => (
                                                    <label key={leadType.value} style={{fontWeight:"normal"}}>
                                                    <input
                                                        type="checkbox"
                                                        name="field_lead_type"
                                                        value={leadType.value}
                                                        // onChange={handleChange}
                                                        onChange={(e) => {
                                                            handleChange(e);

                                                            // Debug logs
                                                            console.log("Clicked Lead Type:", leadType.value);
                                                            console.log("Checked:", e.target.checked);
                                                            console.log("Updated formData.field_lead_type:", formData.field_lead_type);
                                                        }}
                                                        
                                                    />
                                                    {leadType.label}
                                                    </label>
                                                ))}
                                            </>
                                        )} */}
                                        <span class='value'>
                                          {Object.entries(leadList).map(([value, label]) => (
                                    <label key={value} style={{ fontWeight: 'normal' }}>                                      
                                        <input
                                        type="checkbox"
                                        name="field_lead_type"
                                        value={value}
                                        checked={formData.field_lead_type?.includes(value)}
                                        // checked={formData.field_lead_type?.includes(String(value))}
                                        onChange={(e) => handleChange(e)}
                                        />
                                        {label}
                                    </label>
                                    ))} </span>
                                    </div>

                                    <div className="field-row">
                                        <span class='label'>CALL BACK</span>
                                        <span class='value'>
                                        <fieldset className=''>
                                            <div>
                                            {/* <span style={{fontWeight: "bold"}}> </span> */}
                                            </div>
                                            <div className="call-back-container">
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-month">Month </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-month" 
                                                    name="field_call_back_month"
                                                    value={formData.field_call_back_month}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {months.map((m) => (
                                                        <option key={m.value} value={m.value}>
                                                        {m.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                </div>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-day">Day </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-day" 
                                                    name="field_call_back_day"
                                                    value={formData.field_call_back_day}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {days.map((d) => (
                                                    <option key={d.value} value={d.value}>
                                                        {d.label}
                                                    </option>
                                                    ))}  
                                                </select>
                                                </div>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-year">Year </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-year" 
                                                    name="field_call_back_year"
                                                    value={formData.field_call_back_year}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {years.map((y) => (
                                                    <option key={y.value} value={y.value}>
                                                    {y.label}
                                                    </option>
                                                    ))}
                                                </select>
                                                </div>
                                            </div>
                                            <div className="form-item call-back-hour">
                                                <label htmlFor="edit-field-call-back-hour">Hour </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-hour" 
                                                    name="field_call_back_hour"
                                                    value={formData.field_call_back_hour}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {hours.map((h) => (
                                                    <option key={h.value} value={h.value}>
                                                    {h.label}
                                                    </option>
                                                    ))}
                                                </select>
                                                </div>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-minute">Minute </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-minute" 
                                                    name="field_call_back_minute"
                                                    value={formData.field_call_back_minute}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {clock.map((m) => (
                                                    <option key={m} value={m}>
                                                        {m}
                                                    </option>
                                                    ))}
                                                </select>
                                                </div>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-second">Second </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-second" 
                                                    name="field_call_back_second"
                                                    value={formData.field_call_back_second}
                                                    onChange={handleChange}
                                                >
                                                    <option value=""></option>
                                                    {clock.map((s) => (
                                                    <option key={s} value={s}>
                                                        {s}
                                                    </option>
                                                    ))}                              
                                                </select>
                                                </div>
                                            </div>
                                            </div>
                                        </fieldset></span>
                                    </div>
                                    <div style={{clear:"both"}}></div>

                                    <div className="field-row">
                                        <span class='label'><label htmlFor="edit-field-lead-sort-flag">Lead Sort Flag </label></span>
                                        <span class='value'><select 
                                        id="edit-field-lead-sort-flag" 
                                        name="field_lead_sort_flag" 
                                        style={{marginLeft: "0px"}}
                                        value={formData.field_lead_sort_flag}
                                        onChange={handleChange}
                                        >
                                        <option value="_none">- None -</option>
                                        <option value="1">College Credit</option>
                                        <option value="2">G.I. Bill</option>
                                        <option value="3">NOVA</option>
                                        </select></span>
                                    </div>

                                    <div className="field-row">
                                        <span class='label'><label htmlFor="edit-field-lead-priority">Lead Priority </label></span> 
                                        <span class='value'><select 
                                            id="edit-field-lead-priority" 
                                            name="field_lead_priority" 
                                            value={formData.field_lead_priority}
                                            onChange={handleChange}
                                        >
                                            <option value="_none">- None -</option>
                                            <option value="Hot">Hot</option>
                                            <option value="Medium">Medium</option>
                                            <option value="Cold">Cold</option>
                                        </select></span>
                                    </div>
                                </>)}</fieldset>
                                
                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("sortFlagList")} style={{color:"#0074bd", cursor:"pointer"}}>
                               
                                 <div className='section-header'>
                                <span className="toggle-titles">SORT FLAGS</span>
                                 <span style={{ fontSize: '10px' }} className='toggle-icon'>{toggles.sortFlagList ? '▼ ' : '▶ '}</span> </div>
                            </span>
                            {toggles.sortFlagList && (
                                <div className="sort-flag-list">
                                    <label style={{fontWeight: "bold", marginTop: "15px"}}>Sort flags</label>
                                    {sortFlagOptions.length > 0 && ( 
                                        <>
                                            {sortFlagOptions.map(({ id, tid, name }) => (
                                                <label key={id} className="checkbox-item">
                                                <input
                                                    type="checkbox"
                                                    name="sort_flags"
                                                    value={tid}
                                                    // defaultChecked={formData.sort_flags.includes(tid) || false}
                                                    checked={formData.sort_flags.map(String).includes(String(tid))}
                                                    onChange={handleChange}
                                                />
                                                {name}
                                                </label>
                                            ))}
                                        </>
                                    )}
                                </div>
                            )}
                        </fieldset>

                        <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("docTalkList")} style={{color:"#0074bd", cursor:"pointer"}}>
                                 <div className='section-header'>
                                <span className="toggle-titles">DOC TALKS</span>
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.docTalkList ? '▼ ' : '▶ '}</span> </div>
                            </span>
                            {toggles.docTalkList && (
                                <div className="sort-flag-list">
                                    <label style={{fontWeight: "bold", marginTop: "15px"}}>DOC Talks</label>
                                    {Object.entries(docTalkList).length > 0 && (
                                        <>
                                            {Object.entries(docTalkList).map(([value, label]) => (
                                            <label key={value} className="sports-checkbox-item" style={{fontWeight:"normal"}}>
                                                <input
                                                    type="checkbox"
                                                    name="field_doc_talk"
                                                    // checked={formData.field_doc_talk?.includes(value)}  
                                                    // defaultChecked={formData.field_doc_talk?.includes(value) || false}
                                                    checked={formData.field_doc_talk?.includes(value) || false}
                                                    value={value}
                                                    onChange={handleChange}
                                                />
                                                {label}
                                            </label>
                                            ))}
                                        </>
                                    )}
                                </div>
                            )}
                        </fieldset>
                       

                 
                         </>
                    <div className="edit-profile-buttons">
                        <span><button className='edit-profile-submit-button' type="submit">{formData.button_name}</button></span>
                        <span><button className='cancel-button' type="submit" onClick={handleDelete} style={{width: "80px"}}>{formData.delete_button}</button></span>
                        <span><button className='cancel-button' type="submit" onClick={handleCancel} >{formData.cancel_button}</button></span>
                    </div>
                </form>
            ) : (
                <><p>You are not authorized</p></>   
            )}
        </div>
        )}
        </>
    );
    };

    export default ApplicantAdminEditProfile;